import React, { Component, Fragment } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { SkyLightStateless } from 'react-skylight';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import ReactPaginate from 'react-paginate';
import { Field } from 'redux-form';
import { Grid, Row, Col, Panel, Button, ButtonToolbar, Breadcrumb, DropdownButton, MenuItem, Dropdown } from 'react-bootstrap';
import { Translate, I18n } from 'react-redux-i18n';
import _, { debounce } from 'lodash';
import Dropzone from 'react-dropzone';

import Spinner from '../Widgets/spinner';
import ConfirmActionModal from '../Common/confirmActionModal';
import ContentWrapper from '../Layout/ContentWrapper';
import CashFormatter from '../Common/cashFormatter';
import { DateFormatter } from '../Common/dateFormat';
import { Selection } from '../Common/selection';
import TypeRadios from '../../containers/Common/TypeRadios';
import GenericProductSuggest from '../../containers/Common/GenericProductSuggest';
import {
  ROOT_URL, ROOT_API_URL, companyCodeTitle, companyCode, isSH, isAP, isGGI, isSC,
  isOCM, isDAICHEONG, isHMM, isSV, isOLG, isABBLE, isLMH, isBRO, isSDR, isCRW, isEKC, isUSPrideMulti
} from '../../actions/root_url';
import { toFromDates } from '../Common/cleanDates';
import checkPermission from '../Common/permissions';
import genericRadioFilter from '../Common/genericRadioFilter';
import dateFilterRadios from '../Common/dateFilterRadios';
import TrackingNoteModal from '../../containers/Purchase/trackingNoteModal';
import { getLocalStorageData } from '../../reducers/headerRedux';
import PurchaseManagementModals from '../Common/modals/purchaseManagement';
import EmailContentModal from '../Sales/components/EmailContentModal';
import { getKeysMap, getSortVal } from '../../utils';
import { PURCHASE_ORDER_FILTER_KEY_OBJ, PURCHASE_ORDER_SORT_KEY_OBJ } from '../../utils/map';
const {
  MergePOModal,
  SplitPOModal,
  ConvertToSOModal,
} = PurchaseManagementModals;

const isJML = ROOT_API_URL === "https://jml-scm.truckxi.com/api/" || ROOT_URL === "https://jml-scm.truckxi.com/api/";
const isAFGRelated =  (ROOT_URL === "https://afg-scm.truckxi.com/api/" || ROOT_URL === "https://afgstage-scm.truckxi.com/api/" || ROOT_URL === "https://mmdavis-scm.truckxi.com/api/");
const isAFG = ROOT_API_URL === 'https://afg-scm.truckxi.com/api/' || ROOT_URL === 'https://afgstage-scm.truckxi.com/api/';
const isMMD = ROOT_API_URL === 'https://mmdavis-scm.truckxi.com/api/' || ROOT_URL === 'https://mmdavis-scm.truckxi.com/api/';
const isMyuMyu = ROOT_API_URL === 'https://mmstage-scm.truckxi.com/api/' || ROOT_API_URL === 'https://myumyu-scm.truckxi.com/api/';
const isTN = ROOT_API_URL === 'https://tn-scm.truckxi.com/api/' || ROOT_URL === 'https://tn-scm.truckxi.com/api/';
const isPS = ROOT_API_URL === 'https://premiumstella-scm.truckxi.com/api/' || ROOT_URL === 'https://premiumstella-scm.truckxi.com/api/';
const isUSPride = ROOT_API_URL === 'https://uspride-scm.truckxi.com/api/' || ROOT_URL === 'https://uspride-scm.truckxi.com/api/';

const ROWS_FILTER_BY_API_KEYS = ['PONum', 'VendorID', 'VendorName', 'container_num', 'Purchaser_User_Name']

const propTypes = {
  setDefaultDays: PropTypes.func.isRequired,
  setDefaultOfForm: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  resetCurrentPurchaseOrder: PropTypes.func.isRequired,
  selectPurchaseOrder: PropTypes.func.isRequired,
  clearCheckPassword: PropTypes.func.isRequired,
  checkPassword: PropTypes.func.isRequired,
  deletePurchaseOrder: PropTypes.func.isRequired,
  checkPasswordFailure: PropTypes.func.isRequired,
  fetchPurchaseOrdersByFilter: PropTypes.func.isRequired,
  fetchBaseUsers: PropTypes.func.isRequired,
  printPurchaseOrder: PropTypes.func.isRequired,
  setPurchaseOrdersFilter: PropTypes.func.isRequired,
  fetchPurchaseOrderList: PropTypes.func.isRequired,
  resetStatus: PropTypes.func.isRequired,
  purchaseOrdersFilter: PropTypes.object.isRequired,
  checkPasswordSuccess: PropTypes.bool.isRequired,
  purchaseOrders: PropTypes.array.isRequired,
  ProductNum: PropTypes.string.isRequired,
  FromDate: PropTypes.string.isRequired,
  ToDate: PropTypes.string.isRequired,
  requestingPurchaseOrderPdf: PropTypes.bool.isRequired,
  purchaseOrderListIsLoading: PropTypes.bool.isRequired,
  purchaseOrderListError: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  users: PropTypes.array.isRequired,
  usersIsLoading: PropTypes.bool.isRequired,
  Status: PropTypes.string.isRequired,
  Purchaser: PropTypes.object.isRequired,
  Days: PropTypes.string.isRequired,
  purchaseOrderPdf: PropTypes.object.isRequired,
  purchaseOrderList: PropTypes.array.isRequired,
};

class PurchaseOrderList extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      clear: true,

      showTrackingNoteModal: false,

      rows: [],
      selectedRows: [],
      filters: {},
      sortColumn: null,
      sortDirection: null,

      purchaseOrderDetail: {
        rows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },

      emailContentModalVisibility: false,
      emailSubjectTemplate: '',
      emailContentTemplate: '',

      suggestValue: '',
      productSearchType: 'ProductNum',
      days: '7',
      filteredByItem: false,
      currencyCode: '',
      checkAuthorizeOpen: false,
      action: null,

      // for generic radiofilter and datePicker
      FromDate: undefined,
      ToDate: undefined,
      Status: 'all',
      filterProductID: 0,
      PdfFrameLoaded: true,
      PdfFrameLoadedNs: true,
      commercialInvoicePdfFrameLoaded: true,
      packingListPdfFrameLoaded: true,
      orderIds: [],
      validMerge: true,
      mergeModalOpen: false,
      isSearchingRelocated: false,
      Type: null,
      showTotalBoxesPrintDialog: false,
      totalBoxesDialogType: null,
      isMergePOModalVisible: false,
      isSplitPOModalVisible: false,
      currentPage: isOCM ? 0 : undefined,
      limit: isOCM ? 30 : undefined,
      limitDisplay: '30',
      apiSortInfo: {
        sortColumn: null,
        sortDirection: null,
      }
    };

    this.fetchPurchaseOrdersByDetails = this.fetchPurchaseOrdersByDetails.bind(this);
    this.checkAuthorize = this.checkAuthorize.bind(this);
    this.openCheckAuthorize = this.openCheckAuthorize.bind(this);
    this.closeCheckAuthorize = this.closeCheckAuthorize.bind(this);
  }

  componentWillMount() {
    this.props.setDefaultDays('purchaseOrderList');
    this.props.setDefaultOfForm('Status', 'all', 'purchaseOrderList');
  }

  componentDidMount() {
    if (((isEKC || isLMH || isBRO || isSDR || isCRW || isSC) && (this.context.router.routes[1].path === "dropshipOrder"))) {
      this.state.Type = 'Open';
      // this.setState({Type: 'Open'});
    }
    document.title = companyCodeTitle;
    const { purchaseOrdersFilter } = this.props;
    if (purchaseOrdersFilter) {
      const selectedRows = purchaseOrdersFilter.currentRows.filter(r => r.isSelected);
      this.setState({ rows: purchaseOrdersFilter.currentRows, selectedRows, filters: {} });
      this.props.setValue('purchaseOrderList', 'Days', purchaseOrdersFilter.Days);
      this.props.setValue('purchaseOrderList', 'FromDate', purchaseOrdersFilter.FromDate);
      this.props.setValue('purchaseOrderList', 'ToDate', purchaseOrdersFilter.ToDate);
      this.props.setValue('purchaseOrderList', 'Purchaser', purchaseOrdersFilter.Purchaser);
      this.props.setValue('purchaseOrderList', 'Status', purchaseOrdersFilter.Status);
      this.props.setValue('purchaseOrderList', 'ProductNum', purchaseOrdersFilter.ProductNum);
      let fromDate = '1900-01-01';
      if (purchaseOrdersFilter.FromDate) {
        fromDate = this.formatDate(purchaseOrdersFilter.FromDate);
      }
      let toDate = '3000-01-01';
      if (purchaseOrdersFilter.ToDate) {
        toDate = this.formatDate(purchaseOrdersFilter.ToDate);
      }
      let purchaser = purchaseOrdersFilter.Purchaser;
      if (purchaseOrdersFilter.Purchaser) {
        purchaser = purchaseOrdersFilter.Purchaser.value;
      }
      if (isOCM) {
        this.state.currentPage = 0;
      }
      this.props.fetchPurchaseOrdersByFilter(
        this.context.router.routes[1].path,
        fromDate,
        toDate,
        purchaseOrdersFilter.Days,
        purchaseOrdersFilter.Status,
        purchaser,
        purchaseOrdersFilter.ProductNum,
        this.state.Type,
        undefined,
        this.state.productSearchType,
        undefined,
        undefined,
        this.state.limit,
        this.state.currentPage,
        this.getFilterParams(),
      );
      this.props.fetchBaseUsers();
    } else {
      const fromDate = '1900-01-01';
      const toDate = '3000-01-01';
      const days = 7;
      const status = 'all';
      this.props.setDefaultDays('purchaseOrderList');
      this.props.setDefaultOfForm('Status', 'all', 'purchaseOrderList');
      if (isOCM) {
        this.state.currentPage = 0;
      }
      this.props.fetchPurchaseOrdersByFilter(
        this.context.router.routes[1].path,
        fromDate,
        toDate,
        days,
        status,
        null,
        null,
        this.state.Type,
        undefined,
        this.state.productSearchType,
        undefined,
        undefined,
        this.state.limit,
        this.state.currentPage,
        this.getFilterParams(),
      );
      this.props.fetchBaseUsers();
    }
  }

  // Once products are ready, reset state.

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedWarehouse !== this.props.selectedWarehouse && nextProps.selectedWarehouse.value) {
      this.props.fetchBaseUsers();
      this.refreshList()
    }
    if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
      this.closeCheckAuthorize();
      if (this.state.action === 'void') {
        this.deletePurchaseOrder();
      }
    }
    if (nextProps.purchaseOrders && nextProps.purchaseOrders !== this.props.purchaseOrders) {
      if (this.props.purchaseOrdersFilter && this.props.purchaseOrdersFilter.currentRows) {
        const { purchaseOrders } = nextProps;
        let rows = [...this.state.rows];
        rows = rows.map((r) => {
          const index = _.findIndex(purchaseOrders, { PurchaseOrder_id: r.PurchaseOrder_id });
          if (index > -1) {
            r.ETADate = purchaseOrders[index].ETADate;
          } else {
            r = null;
          }
          return r;
        });
        rows = rows.filter(r => r !== null);
        const purchaseOrderDetail = { ...this.state.purchaseOrderDetail, rows: this.props.purchaseOrderList };
        this.setState({ rows, purchaseOrderDetail });
        this.props.setPurchaseOrdersFilter(null);
      } else {
        const rows = nextProps.purchaseOrders;
        if (rows && rows.length !== 0) {
          rows.map((row) => {
            row.Dropship = row.IsDropship ? 'yes' : 'no';
          });
        }
        const purchaseOrderDetail = { ...this.state.purchaseOrderDetail, rows: [] };
        this.setState({ rows, purchaseOrderDetail });
        this.props.setPurchaseOrdersFilter(null);
      }
    }

    if (nextProps.purchaseOrderList && nextProps.purchaseOrderList !== this.props.purchaseOrderList) {
      const purchaseOrderDetail = { ...this.state.purchaseOrderDetail, rows: nextProps.purchaseOrderList };
      this.setState({ purchaseOrderDetail });
    }

    if (nextProps.Status && nextProps.Status !== this.props.Status) {
      const { purchaseOrdersFilter } = this.props;
      if (!purchaseOrdersFilter) {
        let purchaser = this.props.Purchaser;
        if (this.props.Purchaser) {
          purchaser = this.props.Purchaser.value;
        }
        const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
        const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
        let { days } = this.state;
        if (days == null) {
          days = 7;
        }
        const productNum = this.props.ProductNum;
        if (isOCM) {
          this.state.currentPage = 0;
        }
        this.props.fetchPurchaseOrdersByFilter(
          this.context.router.routes[1].path,
          fromDate,
          toDate,
          days,
          nextProps.Status,
          purchaser,
          productNum,
          this.state.Type,
          undefined,
          this.state.productSearchType,
          undefined,
          undefined,
          this.state.limit,
          this.state.currentPage,
          this.getFilterParams(),
        );
      }
    }

    if (nextProps.Purchaser && nextProps.Purchaser !== this.props.Purchaser) {
      const { purchaseOrdersFilter } = this.props;
      if (!purchaseOrdersFilter) {
        let purchaser = nextProps.Purchaser;
        if (nextProps.Purchaser) {
          purchaser = nextProps.Purchaser.value;
        }
        const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
        const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
        const { days } = this.state;
        const productNum = this.props.ProductNum;
        if (isOCM) {
          this.state.currentPage = 0;
        }
        this.props.fetchPurchaseOrdersByFilter(
          this.context.router.routes[1].path,
          fromDate,
          toDate,
          days,
          this.state.Status,
          purchaser,
          productNum,
          this.state.Type,
          undefined,
          this.state.productSearchType,
          undefined,
          undefined,
          this.state.limit,
          this.state.currentPage,
          this.getFilterParams(),
        );
      }
    }

    if (this.props.Purchaser && nextProps.Purchaser == null) {
      const purchaser = nextProps.Purchaser;
      const fromDate = this.props.FromDate ? this.formatDate(this.props.FromDate) : '1900-01-01';
      const toDate = this.props.ToDate ? this.formatDate(this.props.ToDate) : '3000-01-01';
      const days = this.props.Days;
      const productNum = this.props.ProductNum;
      if (isOCM) {
        this.state.currentPage = 0;
      }
      this.props.fetchPurchaseOrdersByFilter(
        this.context.router.routes[1].path,
        fromDate,
        toDate,
        days,
        this.props.Status,
        purchaser,
        productNum,
        this.state.Type,
        undefined,
        this.state.productSearchType,
        undefined,
        undefined,
        this.state.limit,
        this.state.currentPage,
        this.getFilterParams(),
      );
    }

    if (nextProps.Days && nextProps.Days !== this.props.Days) {
      if (nextProps.Days !== -1) {
        this.props.setDefaultOfForm('FromDate', null, 'purchaseOrderList');
        this.props.setDefaultOfForm('ToDate', null, 'purchaseOrderList');
      }
      this.setState({ days: nextProps.Days });
    }

    if (nextProps.purchaseOrderPdf && nextProps.purchaseOrderPdf !== this.props.purchaseOrderPdf) {
      this.setState({ PdfFrameLoaded: false });
    }

    if (nextProps.purchaseOrderPdfNs && nextProps.purchaseOrderPdfNs !== this.props.purchaseOrderPdfNs) {
      this.setState({ PdfFrameLoadedNs: false });
    }

    if (nextProps.commercialInvoicePdf && nextProps.commercialInvoicePdf !== this.props.commercialInvoicePdf) {
      this.setState({commercialInvoicePdfFrameLoaded: false});
    }

    if(nextProps.packingListPdf && nextProps.packingListPdf !== this.props.packingListPdf) {
      this.setState({packingListPdfFrameLoaded: false});
    }

    if (typeof this.props.FromDate !== 'undefined' && typeof this.props.ToDate !== 'undefined' && (nextProps.FromDate !== this.props.FromDate || nextProps.ToDate !== this.props.ToDate)) {
      let FromDate;
      let ToDate;
      let purchaser = this.props.Purchaser;
      if (nextProps.FromDate != null) {
        FromDate = this.formatDate(nextProps.FromDate);
      }
      if (nextProps.ToDate != null) {
        ToDate = this.formatDate(nextProps.ToDate);
      }
      if (this.props.Purchaser) {
        purchaser = this.props.Purchaser.value;
      }
      if (isOCM) {
        this.state.currentPage = 0;
      }
      this.props.fetchPurchaseOrdersByFilter(
        this.context.router.routes[1].path,
        FromDate,
        ToDate,
        -1,
        this.props.Status,
        purchaser,
        this.state.filterProductID,
        this.state.Type,
        undefined,
        this.state.productSearchType,
        undefined,
        undefined,
        this.state.limit,
        this.state.currentPage,
        this.getFilterParams(),
      );
    }

    if (nextProps.mergePurchaseOrderSuccess && nextProps.mergePurchaseOrderSuccess !== this.props.mergePurchaseOrderSuccess) {
      this.cancelMergeRequest();
      const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
      const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
      let { days } = this.state;
      if (days == null) {
        days = 7;
      }
      let purchaser = this.props.Purchaser;
      if (this.props.Purchaser) {
        purchaser = this.props.Purchaser.value;
      }
      const productNum = this.props.ProductNum;
      if (isOCM) {
        this.state.currentPage = 0;
      }
      this.props.fetchPurchaseOrdersByFilter(
        this.context.router.routes[1].path,
        fromDate,
        toDate,
        days,
        nextProps.Status,
        purchaser,
        productNum,
        this.state.Type,
        undefined,
        this.state.productSearchType,
        undefined,
        undefined,
        this.state.limit,
        this.state.currentPage,
        this.getFilterParams(),
      );
    }

    if (nextProps.mergePurchaseOrderError && nextProps.mergePurchaseOrderError !== this.props.mergePurchaseOrderError) {
      this.cancelMergeRequest();
      alert(nextProps.mergePurchaseOrderError)
    }

    if (nextProps.currentPage && nextProps.currentPage !== this.props.currentPage) {
      this.setState({ currentPage: nextProps.currentPage });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.PdfFrameLoaded !== this.state.PdfFrameLoaded && !this.state.PdfFrameLoaded) {
      return false;
    }
    if (nextState.PdfFrameLoadedNs !== this.state.PdfFrameLoadedNs && !this.state.PdfFrameLoadedNs) {
      return false;
    }
    if (nextState.commercialInvoicePdfFrameLoaded !== this.state.commercialInvoicePdfFrameLoaded && !this.state.commercialInvoicePdfFrameLoaded) {
      return false;
    }
    if (nextState.packingListPdfFrameLoaded !== this.state.packingListPdfFrameLoaded && !this.state.packingListPdfFrameLoaded) {
      return false;
    }

    return true;
  }

  componentWillUnmount() {
    if (this.state.clear) {
      this.props.setPurchaseOrdersFilter(null);
    }
  }

  // Used for new generic datePicker//////////////////////////////
  setToDate = (e) => {
    if (e < this.state.FromDate) {
      return;
    }
    this.setState({ ToDate: e });
  };

  setFromDate = (e) => {
    if (e > this.state.ToDate) {
      return;
    }
    this.setState({ FromDate: e });
  };

  setToRangeSearch = () => {
    this.setState({ days: '-1' });
  };

  handleOptionChange = (changeEvent) => {
    this.setState({ productSearchType: changeEvent.target.value });
  };

  handleRelocatedSearchCheckClick = (e) => {
    this.setState({
      isSearchingRelocated: !this.state.isSearchingRelocated,
    });
  }

  checkAuthorize(password) {
    this.props.checkPassword(password);
  }

  openCheckAuthorize(action) {
    this.props.clearCheckPassword();
    this.setState({ checkAuthorizeOpen: true, action });
  }

  closeCheckAuthorize() {
    this.setState({ checkAuthorizeOpen: false });
  }

  formatDate(date) {
    let formattedDate = `${date.getFullYear()}-`;

    formattedDate += `${date.getMonth() + 1}-`;
    if (date.getDate() < 10) {
      formattedDate += `0${date.getDate()}`;
    } else {
      formattedDate += date.getDate();
    }

    return formattedDate;
  }

  // Set product being selected to be currentProduct and navigate user to the edit page

  setCurrentPurchaseOrder(e) {
    e.preventDefault();
    this.setState({ clear: false });
    const currentPurchaseOrder = this.state.selectedRows[0];
    const { FromDate } = this.props;
    const { ToDate } = this.props;
    this.props.resetCurrentPurchaseOrder();
    this.props.selectPurchaseOrder(currentPurchaseOrder);
    const currentRows = Data.Selectors.getRows(this.state);
    this.props.setPurchaseOrdersFilter({
      Days: this.props.Days,
      FromDate,
      ToDate,
      Status: this.props.Status,
      Purchaser: this.props.Purchaser,
      ProductNum: this.props.ProductNum,
      currentRows,
    });
    this.context.router(`/purchaseOrder/${currentPurchaseOrder.PurchaseOrder_id}`);
  }

  printPurchaseOrder(e) {
    e.preventDefault();
    const currentPurchaseOrder = this.state.selectedRows[0];
    this.props.printPurchaseOrder(currentPurchaseOrder.PurchaseOrder_id);
  }

  deletePurchaseOrder() {
    // e.preventDefault();
    const currentPurchaseOrder = this.state.selectedRows[0];
    this.props.deletePurchaseOrder(currentPurchaseOrder.PurchaseOrder_id);
  }

  shouldVoidButtonDisable() {
    const { selectedRows } = this.state;

    // Always disable void if selected more than 1 row
    if (selectedRows === null || selectedRows.length !== 1) {
      return true;
    }

    const status = selectedRows[0] ? selectedRows[0].PurchaseStatus : 'disable';
    let disabled = status !== 'Placed' || status === 'disable';
    if ((isMMD || isAFG) && (status === 'Pending' || status === 'Merged')) {
      disabled = false;
    }
    return disabled;
  }

  submitApprovePO(selectedRows) {
    let output = [];
    selectedRows.map(r=>{
      output.push(r.id);
    });
    this.props.approvePendingPO(output)
      .then((response) => {
        alert('PO Approved');
        this.refreshList();
      }, (err) => {
        if (err.status === 500 || err.status === 404) {
          err.data = DEFAULT_ERROR;
        }
        alert('Error: ' + err.data);
      });
  }

  genSubjectTemplate = () => {
      const row = this.state.selectedRows[0];
      const activeCompany = getLocalStorageData('selectedCompany').label;
      if(row) {
        const poNum = row.PONum;
        return `Purchase Order ${poNum} from ${activeCompany.toUpperCase()}`
      }
    return ''
  }

  genContentTemplate = () => {
      const activeCompany = getLocalStorageData('selectedCompany').label;
      return `Dear Customer:

Your purchase order is attached. Please review the list of items on order.
Thank you for your business - we appreciate it very much

Sincerely,
${activeCompany.toUpperCase()}.`
  }

  handleEmailContentClose = () => {
    this.setState({
      emailContentModalVisibility: false,
      emailSubjectModalTemplate: '',
      emailContentModalTemplate: ''
    })
  }

  handleEmailContentConfirm = (subject, content, email) => {
    const row = this.state.selectedRows[0];
    if(row) {
      this.props.emailPOPost(row.PurchaseOrder_id, subject, content, email);
      this.handleEmailContentClose();
    }
  }

  refreshList(clearSelectedRow = false) {
    // const { purchaseOrdersFilter } = this.props;
    let { selectedRows } = this.state;
    let newRows = this.state.rows;
    const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
    const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
    let { days } = this.state;
    if (days == null) {
      days = 7;
    }
    let purchaser = this.props.Purchaser;
      if (this.props.Purchaser) {
        purchaser = this.props.Purchaser.value;
      }
    const productNum = this.props.ProductNum;
    if (isOCM) {
      this.state.currentPage = 0;
    }
    this.props.fetchPurchaseOrdersByFilter(
      this.context.router.routes[1].path,
      fromDate,
      toDate,
      days,
      this.state.Status,
      purchaser,
      productNum,
      this.state.Type,
      this.state.suggestValue,
      this.state.productSearchType,
      undefined,
      undefined,
      this.state.limit,
      this.state.currentPage,
      this.getFilterParams(),
    );

    if (clearSelectedRow) {
      this.setState({
        selectedRows: [],
      })
    } else {
      setTimeout(() => {
        newRows = this.state.rows;
        if (newRows) {
          newRows.map((r, i)=>{
            selectedRows.map((s, j)=>{
              if (r.id === s.id) {
                selectedRows[j] = r;
                newRows[i].isSelected = true;
              }
            });
          });
        }
        this.setState({ ...this.state, selectedRows, rows: newRows});
      }, 1000);
    }
  }

  clickNew(e) {
    e.preventDefault();
    this.props.resetCurrentPurchaseOrder();
    this.context.router.push('/purchaseOrder/new');
  }

  renderUsers() {
    if (this.props.usersIsLoading) return <Spinner />; // If group is loading, show a spinner.

    const Users = this.getUsers();
    return (
      <div className="control-dropdown">
        <Field name="Purchaser" component={Selection} options={Users} />
      </div>
    );
  }

  getUsers() {
    const Users = [];
    this.props.users.map((user) => {
      Users.push({ value: user.user_id, label: user.username });
    });
    return Users;
  }

  handleStatusFilterChange = (status) => {
    const { purchaseOrdersFilter } = this.props;
    if (!purchaseOrdersFilter) {
      let purchaser = this.props.Purchaser;
      if (this.props.Purchaser) {
        purchaser = this.props.Purchaser.value;
      }
      const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
      const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
      let { days } = this.state;
      if (days == null) {
        days = 7;
      }
      const productNum = this.props.ProductNum;
      this.setState({ Status: status }, () => {
        if (isOCM) {
          this.state.currentPage = 0;
        }
        this.props.fetchPurchaseOrdersByFilter(
          this.context.router.routes[1].path,
          fromDate,
          toDate,
          days,
          this.state.Status,
          purchaser,
          productNum,
          this.state.Type,
          undefined,
          this.state.productSearchType,
          undefined,
          undefined,
          this.state.limit,
          this.state.currentPage,
          this.getFilterParams(),
        );
      });
    } else {
      this.setState({ Status: status });
    }
  };

  handleTypeFilterChange = (Type) => {
    let purchaser = this.props.Purchaser;
    if (this.props.Purchaser) {
      purchaser = this.props.Purchaser.value;
    }
    const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
    const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
    let { days } = this.state;
    if (days == null) {
      days = 7;
    }
    const productNum = this.props.ProductNum;
    this.setState({ Type }, () => {
      if (isOCM) {
        this.state.currentPage = 0;
      }
      this.props.fetchPurchaseOrdersByFilter(
        this.context.router.routes[1].path,
        fromDate,
        toDate,
        days,
        this.state.Status,
        purchaser,
        productNum,
        Type,
        undefined,
        this.state.productSearchType,
        undefined,
        undefined,
        this.state.limit,
        this.state.currentPage,
        this.getFilterParams(),
      );
    });
  }

  refreshPOList = () => {
    const status = this.state.Status;
    const { purchaseOrdersFilter } = this.props;
    if (!purchaseOrdersFilter) {
      let purchaser = this.props.Purchaser;
      if (this.props.Purchaser) {
        purchaser = this.props.Purchaser.value;
      }
      const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
      const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
      let { days } = this.state;
      if (days == null) {
        days = 7;
      }
      const productNum = this.props.ProductNum;
      this.setState({ Status: status }, () => {
        if (isOCM) {
          this.state.currentPage = 0;
        }
        this.props.fetchPurchaseOrdersByFilter(
          this.context.router.routes[1].path,
          fromDate,
          toDate,
          days,
          this.state.Status,
          purchaser,
          productNum,
          this.state.Type,
          undefined,
          this.state.productSearchType,
          undefined,
          undefined,
          this.state.limit,
          this.state.currentPage,
          this.getFilterParams(),
        );
      });
    } else {
      this.setState({ Status: status });
    }
  }

  fetchPurchaseOrdersByDetails(days) {
    if (this.state.filteredByItem) {
      this.setState({ days }, () => {
        this.fetchPurchaseOrdersByProduct(this.state.filterProductID);
      });
      return;
    }
    let FromDate = '1900-01-01';
    let ToDate = '3000-01-01';
    let purchaser = this.props.Purchaser;
    const productNum = this.props.ProductNum;
    if (this.state.FromDate != null) {
      FromDate = this.formatDate(this.state.FromDate);
    }
    if (this.state.ToDate != null) {
      ToDate = this.formatDate(this.state.ToDate);
    }

    if (this.props.Purchaser) {
      purchaser = this.props.Purchaser.value;
    }

    if (days === '-1' || days === -1) {
      this.setState({ days }, () => {
        if (isOCM) {
          this.state.currentPage = 0;
        }
        this.props.fetchPurchaseOrdersByFilter(
          this.context.router.routes[1].path,
          FromDate,
          ToDate,
          days,
          this.state.Status,
          purchaser,
          productNum,
          this.state.Type,
          undefined,
          this.state.productSearchType,
          undefined,
          undefined,
          this.state.limit,
          this.state.currentPage,
          this.getFilterParams(),
        );
      });
    } else {
      this.setState({ days, FromDate: undefined, ToDate: undefined }, () => {
        if (isOCM) {
          this.state.currentPage = 0;
        }
        this.props.fetchPurchaseOrdersByFilter(
          this.context.router.routes[1].path,
          FromDate,
          ToDate,
          days,
          this.state.Status,
          purchaser,
          productNum,
          this.state.Type,
          undefined,
          this.state.productSearchType,
          undefined,
          undefined,
          this.state.limit,
          this.state.currentPage,
          this.getFilterParams(),
        );
      });
    }
    this.setState({ selectedRows: [], days });
  }

  fetchPurchaseOrdersByProduct = (productID) => {
    let dateRange = -1;
    let FromDate = '1900-01-01';
    let ToDate = '3000-01-01';
    let purchaser = this.props.Purchaser;
    const productNum = productID;
    if (this.state.FromDate != null) {
      FromDate = this.formatDate(this.state.FromDate);
    }

    if (this.state.ToDate != null) {
      ToDate = this.formatDate(this.state.ToDate);
    }

    if (this.state.days != null && typeof this.state.days !== 'undefined') {
      dateRange = this.state.days;
    }

    if (this.props.Purchaser) {
      purchaser = this.props.Purchaser.value;
    }
    this.setState({ filteredByItem: true, selectedRows: [{}], filterProductID: productID });
    if (isOCM) {
      this.state.currentPage = 0;
    }
    this.props.fetchPurchaseOrdersByFilter(
      this.context.router.routes[1].path,
      FromDate,
      ToDate,
      dateRange,
      this.state.Status,
      purchaser,
      productNum,
      this.state.Type,
      undefined,
      this.state.productSearchType,
      undefined,
      undefined,
      this.state.limit,
      this.state.currentPage,
      this.getFilterParams(),
    );
  };

  // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.
  getFilterParams = () => {
    let filterParams = ''
    if (isOCM) {
      const filterPaires = [];
      _.forOwn(this.state.filters, (value, key) => {
        if (!ROWS_FILTER_BY_API_KEYS.includes(key)) {
          return;
        }
        filterPaires.push([getKeysMap(key, PURCHASE_ORDER_FILTER_KEY_OBJ), value.filterTerm].join('='))
      });
      filterParams = filterPaires.join('&');
      const {sortColumn, sortDirection} = this.state.apiSortInfo;
      if (['ASC', 'DESC'].includes(sortDirection)) {
        const key = getKeysMap(sortColumn, PURCHASE_ORDER_SORT_KEY_OBJ);
        const sort = getSortVal(key,sortDirection === "DESC");
        filterParams += `&sort=${sort}`;
      }
    }

    if (isSV) {
      filterParams += '&IsGL=true'
    }
    return filterParams;
  }

  renderTable() {
    if (this.props.isLoading && !this.props.error && !isOCM) return <Spinner />;
    else if (this.props.error) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.error)}</div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid

    const tableHeight = window.innerHeight < 930 ? 270 : 270;

    const getRows = () => Data.Selectors.getRows(this.state);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    const onRowClick = (rowIdx, row) => {
      if (rowIdx !== -1) {
        const rows = getRows();
        rows.map((r) => {
          r.isSelected = false;
        });
        rows[rowIdx].isSelected = true;
        this.setState({ rows, selectedRows: [rows[rowIdx]], currencyCode: row.CurrencyCode});
        this.props.fetchPurchaseOrderList(row.PurchaseOrder_id);
      }
    };

    const onCellSelected = (coordinates) => {
      const rows = getRows();
      rows.map((r) => {
        r.isSelected = false;
      });
      rows[coordinates.rowIdx].isSelected = true;
      this.setState({ rows, selectedRows: [rows[coordinates.rowIdx]] });
    };

    const onClearFilters = () => {
      // all filters removed
      this.setState({ filters: {} }, () => {
        if (isOCM) {
          handleOnPageChange({
            selected: 0,
          })
        }
      });
    };

    // Handle the sortable function

    const handleGridSort = (sortColumn, sortDirection) => {
      if (isOCM) {
        this.setState({
          apiSortInfo: {sortColumn, sortDirection},
        }, () => {
          handleSortChangeGetData();
        })
      } else {
        const state = Object.assign({}, this.state, { sortColumn, sortDirection });
        this.setState(state);
      }
    };

    const defaultHandleFilterChange = (filter) => {
      const { rows } = this.state;
      if (rows && rows.length !== 0) {
        rows.map((row) => {
          row.Dropship = row.IsDropship ? 'yes' : 'no';
        });
      }
      this.setState({ rows });
      const newFilters = Object.assign({}, this.state.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      this.setState({ filters: newFilters });
    }
    const ocmHandleFilterChange = debounce(
      (filter) => {
        const { rows } = this.state;
        if (rows && rows.length !== 0) {
          rows.map((row) => {
            row.Dropship = row.IsDropship ? 'yes' : 'no';
          });
        }
        this.setState({ rows });
        const newFilters = Object.assign({}, this.state.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        this.setState({ filters: newFilters }, () => {
          if (!ROWS_FILTER_BY_API_KEYS.includes(filter.column.key)) {
            return
          }
          handleOnPageChange({
            selected: 0
          })
        });
      },
      500,
      { maxWait: 800 },
    );
    const handleFilterChange = isOCM ? ocmHandleFilterChange : defaultHandleFilterChange

    const onRowsSelected = (rows) => {
      const newRows = getRows();
      let selectedRows = [];
      rows.map(r => {
        newRows[r.rowIdx].isSelected = true;
      });

      newRows.map(r => {
        if (r.isSelected === true) {
          selectedRows.push(r);
        }
      });
      this.setState({ ...this.state, selectedRows, rows: newRows}, () => {
        this.mergePurchaseRows();
      })

    };
    const onRowsDeselected = (rows) => {
      const newRows = [...this.state.rows];
      const selectedRows = [...this.state.selectedRows];
      rows.map((r) => {
        newRows[r.rowIdx].isSelected = false;
        const rowIndex = selectedRows.indexOf(r.row);
        selectedRows.splice(rowIndex, 1);
      });
      this.setState({ rows: newRows, selectedRows });
    };

    const handlePageChangeGetData = () => {
      let purchaser = this.props.Purchaser;
      if (this.props.Purchaser) {
        purchaser = this.props.Purchaser.value;
      }
      const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
      const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
      let { days } = this.state;
      if (days == null) {
        days = 7;
      }
      const productNum = this.props.ProductNum;
      this.props.fetchPurchaseOrdersByFilter(
        this.context.router.routes[1].path,
        fromDate,
        toDate,
        days,
        this.state.Status,
        purchaser,
        productNum,
        this.state.Type,
        undefined,
        this.state.productSearchType,
        undefined,
        undefined,
        this.state.limit,
        this.state.currentPage,
        this.getFilterParams(),
      );
    }
    const handleSortChangeGetData = handlePageChangeGetData;
    const handleLimitChange = (el) => {
      this.state.currentPage = 0;
      this.state.limit = el.value;
      this.state.limitDisplay = el.label;
      this.setState({selectedRows: []});
      handlePageChangeGetData();
    }
    const handleOnPageChange = (data) => {
      this.state.currentPage = data.selected;
      handlePageChangeGetData();
    }

    const StatusFormatter = React.createClass({
      getStatus() {
        const {
          dependentValues,
          value,
        } = this.props;
        if (value === 'Placed' && dependentValues.container_num) {
          return 'In Transit';
        };
        return value;
      },
      render() {
        return (
          <span>{this.getStatus()}</span>
        )
      }
    })

    const limitSelection = [{
      label: '30',
      value: 30,
      name: 'limit',
    }]

    let columns = [
      {
        key: 'PONum',
        name: <Translate value="po_num" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      ...isABBLE ? [] : [{
        key: 'VendorID',
        name: <Translate value="vendor_no" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }],
      {
        key: 'VendorName',
        name: <Translate value="vendor_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 200,
      },
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC) ? [] : [{
        key: 'container_num',
        name: <Translate value="container_num" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      }],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC || isABBLE) ? [] : [{
        key: 'fob_point',
        name: <Translate value="fob_point" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      }],
      ...isABBLE ? [{
        key: 'Loading_Port',
        name: <Translate value="loading_port" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }] : [],
      ...isDAICHEONG ? [{
        key: 'TotalQuantity',
        name: <Translate value="total_qty" />,
        resizable: true,
        sortable: true,
        width: 60,
        filterable: true,
      }] : [],
      {
        key: 'FinalPrice',
        name: <Translate value="final_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 75,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: 'OrderDate',
        name: <Translate value="ordered" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
        formatter: DateFormatter,
      },
      ...isABBLE ? [
        {
          key: 'start_date',
          name: <Translate value="shipping_start" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          formatter: DateFormatter,
        },{
          key: 'end_date',
          name: <Translate value="shipping_end" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          formatter: DateFormatter,
        }, {
          key: 'ETD_date',
          name: <Translate value="etd_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          formatter: DateFormatter,
        }
      ] : [],
      {
        key: 'ETADate',
        name: <Translate value="eta_date" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
        formatter: DateFormatter,
      },
      ...isABBLE ? [{
        key: 'ReceivedDate',
        name: <Translate value="receive_date" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
        formatter: DateFormatter,
      }] : [],
      ...isSV ? [{
        key: 'onboard_date',
        name: <Translate value="onboard_date" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
        formatter: DateFormatter,
      },
      {
        key: 'cancel_date',
        name: <Translate value="cancel_date" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
        formatter: DateFormatter,
      }] : [],
      ...isABBLE ? [{
        key: 'total_cbm',
        name: <Translate value="cbm" />,
        resizable: true,
        sortable: true,
        width: 70,
        filterable: true,
      },{
        key: 'total_CTN',
        name: <Translate value="ctn" />,
        resizable: true,
        sortable: true,
        width: 70,
        filterable: true,
      },{
        key: 'total_PCS',
        name: <Translate value="pcs" />,
        resizable: true,
        sortable: true,
        width: 70,
        filterable: true,
      }] : [],
      {
        key: 'ShipTo',
        name: <Translate value="shipto" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      },
      ...isUSPrideMulti ? [{
        key: 'PurchaseStatus',
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: StatusFormatter,
        getRowMetaData: row => row,
      }] : [{
        key: 'PurchaseStatus',
        name: <Translate value="status" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
      }],
      ...((isEKC || isLMH || isBRO || isSDR || isCRW || isSC) && (this.context.router.routes[1].path === "dropshipOrder")) ? [{
        key: 'DropshipStatus',
        name: <Translate value="dropship_status" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 110,
        getRowMetaData: row => row,
        formatter: ({ value }) => (
          <div
            style={{ width: "100%", height: "100%", textAlign: "center" }}
          >
            {(value === 'Complete') ? 'Ordered' : 'Pending'}
          </div>
        ),
      }] : [],
      ...isABBLE ? [] : [{
        key: 'ReceivedDate',
        name: <Translate value="receive_date" />,
        resizable: true,
        sortable: true,
        width: 90,
        filterable: true,
        formatter: DateFormatter,
      }],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC) ? [] : [{
        key: 'Dropship',
        name: <Translate value="ds" />,
        resizable: true,
        sortable: true,
        width: 40,
        filterable: true,
      }],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC) ? [] : [{
        key: 'Purchaser_User_Name',
        name: <Translate value="purchaser" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC) ? [] : [{
        key: 'ShippingCost',
        name: <Translate value="ship_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 65,
        filterable: true,
        formatter: CashFormatter,
      }],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC) ? [] : [ {
        key: 'MiscCost',
        name: <Translate value="misc_dollarsign" />,
        resizable: true,
        sortable: true,
        width: 65,
        filterable: true,
        formatter: CashFormatter,
      }],
      ...isABBLE ? [{
        key: 'VendorID',
        name: <Translate value="vendor_no" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }] : [],
    ];


    if(isSH || isAP) {
      columns.push({
        key: 'Boln',
        name: <Translate value="bol" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }, {
        key: 'MeasurementInCBM',
        name: <Translate value="measurement_in_cbm" />,
        resizable: true,
        sortable: true,
        width: 130,
        filterable: true,
      }, {
        key: 'GrossWeight',
        name: <Translate value="gross_weight" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      })
    }

    if (isGGI) {
      const purchaserIndex = _.findIndex(columns, { key: 'Purchaser_User_Name' });
      const dropShipIndex = _.findIndex(columns, { key: 'Dropship' });
      const creator = {
        key: 'Purchaser_User_Name',
        name: <Translate value="creator" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }
      const newPuchaser = {
        key: 'Purchaser_name',
        name: <Translate value="purchaser" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }
      const tsoNum = {
        key: 'TSONum',
        name: <Translate value="TSO" />,
        resizable: true,
        sortable: true,
        width: 100,
        filterable: true,
      }
      columns.splice(purchaserIndex, 1, creator, newPuchaser);
      columns.splice(dropShipIndex + 1, 0, tsoNum);
    }
    if (isTN) {
      columns = [
        {
          key: 'PONum',
          name: <Translate value="po_num" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },

        {
          key: "container_num",
          name: <Translate value="container_no" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'VendorID',
          name: <Translate value="vendor_no" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'VendorName',
          name: <Translate value="vendor_name" />,
          resizable: true,
          sortable: true,
          filterable: true,
          width: 200,
        },
        {
          key: "customer_name",
          name: "Client.Cust",
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        // {
        //   key: 'FinalPrice',
        //   name: <Translate value="final_dollarsign" />,
        //   resizable: true,
        //   sortable: true,
        //   width: 75,
        //   filterable: true,
        //   formatter: CashFormatter,
        // },
        {
          key: 'OrderDate',
          name: <Translate value="ordered" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          formatter: DateFormatter,
        },
        {
          key: 'ETADate',
          name: <Translate value="eta_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          formatter: DateFormatter,
        },
        {
          key: "order_type",
          name: <Translate value="po_type" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: "refnum1",
          name: <Translate value="ref#1" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
          },
        {
          key: "refnum2",
          name: <Translate value="ref#2" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'ShipTo',
          name: <Translate value="shipto" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: 'PurchaseStatus',
          name: <Translate value="status" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'ReceivedDate',
          name: <Translate value="receive_date" />,
          resizable: true,
          sortable: true,
          width: 90,
          filterable: true,
          formatter: DateFormatter,
        },
        {
          key: 'Dropship',
          name: <Translate value="ds" />,
          resizable: true,
          sortable: true,
          width: 40,
          filterable: true,
        },
        {
          key: 'Purchaser_User_Name',
          name: <Translate value="purchaser" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        // {
        //   key: 'ShippingCost',
        //   name: <Translate value="ship_dollarsign" />,
        //   resizable: true,
        //   sortable: true,
        //   width: 65,
        //   filterable: true,
        //   formatter: CashFormatter,
        // },
        // {
        //   key: 'MiscCost',
        //   name: <Translate value="misc_dollarsign" />,
        //   resizable: true,
        //   sortable: true,
        //   width: 65,
        //   filterable: true,
        //   formatter: CashFormatter,
        // },
      ];
    }

    const showPagination = isOCM
    const totalPages = this.props.totalPages
    // React Table Purchase Order Full Table
    return (
      <div>
        <Row>
          <Col xs={12}>
            <div id="PurchaseOrderList-dataGrid1">
              <ReactDataGrid
                rowKey="PurchaseOrder_id"
                enableCellSelect
                onClearFilters={onClearFilters}
                onGridSort={handleGridSort}
                toolbar={<Toolbar enableFilter />}
                onAddFilter={handleFilterChange}
                columns={columns}
                rowHeight={25}
                headerRowHeight={45}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={tableHeight}
                enableRowSelect="multi"
                onRowUpdated={this.handleRowUpdated}
                rowSelection={{
                  showCheckbox: true,
                  onRowsSelected,
                  onRowsDeselected,
                  selectBy: {
                    isSelectedKey: 'isSelected',
                  },
                }}
                onRowClick={onRowClick}
                onCellSelected={onCellSelected}
              />
            </div>
          </Col>
        </Row>
        {
          showPagination && <Row>
            <Col xs={6} style={{display: 'flex'}}>
              <div style={{ width: '600px' }} id="react-pagination">
                <ReactPaginate
                  previousLabel={<Translate value="prev_page" />}
                  nextLabel={<Translate value="next_page" />}
                  containerClassName={'pagination'}
                  activeClassName={'active'}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  pageCount={totalPages}
                  onPageChange={handleOnPageChange}
                  forcePage={this.state.currentPage}
                />
              </div>
              <div  style={{ width: '100px', marginTop: '6px', marginLeft: '15px'}}>
                <Dropdown>
                  <Dropdown.Toggle style={{ height: '28px', width: '60px', backgroundColor: 'white', border: '1px solid #555555', color: 'black', fontWeight: '400' }}>
                    {this.state.limitDisplay}
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="super-colors">
                    {limitSelection.map(el => {
                      return (
                        <MenuItem onClick={() => handleLimitChange(el)}>{el.label}</MenuItem>
                      )
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Col>
          </Row>
        }
      </div>
    );
  }

  renderProductsTable() {
    if (this.props.purchaseOrderListIsLoading && !this.props.purchaseOrderListError) return <Spinner />;
    else if (this.props.purchaseOrderListError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.purchaseOrderListError)}</div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid

    const tableHeight = window.innerHeight < 930 ? 185 : 185;

    const getRows = () => Data.Selectors.getRows(this.state.purchaseOrderDetail);

    const getSize = () => getRows().length;

    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function

    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state.purchaseOrderDetail, { sortColumn, sortDirection });
      this.setState({ purchaseOrderDetail: state });
    };

    const onClearFilters = () => {
      // all filters removed
      const purchaseOrderDetail = { ...this.state.purchaseOrderDetail, filters: {} };
      this.setState({ purchaseOrderDetail });
    };

    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.purchaseOrderDetail.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      const purchaseOrderDetail = { ...this.state.purchaseOrderDetail, filters: newFilters };
      this.setState({ purchaseOrderDetail });
    };

    const onRowSelect = (rows) => {
      const purchaseOrderDetail = { ...this.state.purchaseOrderDetail, selectedRows: rows };
      this.setState({ purchaseOrderDetail });
    };

    // Column definition
    let columns = (!this.state.currencyCode || this.state.currencyCode === 'USD')
    ?
    [
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC) ? [] : [{
        key: 'ProductNum',
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      }],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC) ? [] : [{
        key: 'RefNum',
        name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
        resizable: true,
        sortable: true,
        width: 100,
      }],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC) ? [] : [{
        key: 'VendorProductNum',
        name: <Translate value="vendor_product_number" />,
        resizable: true,
        sortable: true,
        width: 150,
      }],
      {
        key: 'Name',
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 250,
      },
      {
        key: 'Description',
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 200,
      },
      ...(isSV) ? [{
        key: 'Barcode',
        name: <Translate value="barcode" />,
        resizable: true,
        sortable: true,
        width: 150,
      }] : [],
      ...(isABBLE || isEKC || isLMH || isBRO || isSDR || isCRW || isSC) ? [] : [{
        key: 'expire_date',
        name: <Translate value="expire_date" />,
        resizable: true,
        sortable: true,
        width: 80,
      }],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC) ? [] : [{
        key: 'PackageType',
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 50,
        sortable: true,
      }],
      {
        key: 'OrderQuantity',
        name: isABBLE ? <Translate value="ctn" /> : <Translate value="order_qty" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      ...isABBLE ? [{
        key: 'purchase_convert_unit',
        name: <Translate value="convert_quantity" />,
        resizable: true,
        width: 90,
        sortable: true,
      },{
        key: 'psc_quantity',
        name: <Translate value="pcs" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC) ? [] : [{
        key: 'OrderTotalNetWeight',
        name: <Translate value="order_wt" />,
        resizable: true,
        width: 70,
        sortable: true,
      }],
      {
        key: 'OrderUnitPrice',
        name: <Translate value="order_unit_dollarsign" />,
        resizable: true,
        width: 110,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: 'OrderTotalPrice',
        name: <Translate value="order_total_dollarsign" />,
        resizable: true,
        width: 110,
        sortable: true,
        formatter: CashFormatter,
      },
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC || isABBLE) ? [] : [{
          key: isPS ? 'dimension' : 'dimension_shipping',
          name: isPS ? 'DIM (in)' : <Translate value="package_dimension_shipping" />,
          resizable: true,
          width: 95,
          sortable: true,
      }],
      ...isABBLE ? [{
        key: 'cbm',
        name: <Translate value="CBM" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [],
      ...(isEKC || isLMH || isBRO || isSDR || isCRW || isSC) ? [] : [{
        key: 'weight_shipping',
        name: <Translate value="package_weight_shipping" />,
        resizable: true,
        width: 95,
        sortable: true,
      }, {
        key: 'ReceiveQuantity',
        name: <Translate value="receive_qty" />,
        resizable: true,
        width: 70,
        sortable: true,
      },{
        key: 'ReceiveTotalWeight',
        name: <Translate value="receive_wt" />,
        resizable: true,
        width: 70,
        sortable: true,
      },{
        key: 'ReceiveUnitPrice',
        name: <Translate value="receive_unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      }, {
        key: 'ReceiveTotalPrice',
        name: <Translate value="receive_total_dollarsign" />,
        resizable: true,
        width: 80,
        sortable: true,
        formatter: CashFormatter,
      }],
    ]
    :
    [
      {
        key: 'ProductNum',
        name: <Translate value="product_num" />,
        resizable: true,
        sortable: true,
        width: 100,
      },
      {
        key: 'RefNum',
        name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
        resizable: true,
        sortable: true,
        width: 70,
      },
      {
        key: 'Name',
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        width: 250,
      },
      {
        key: 'Description',
        name: <Translate value="description" />,
        resizable: true,
        sortable: true,
        width: 200,
      },
      {
        key: 'expire_date',
        name: <Translate value="expire_date" />,
        resizable: true,
        sortable: true,
        width: 80,
      },
      {
        key: 'PackageType',
        name: <Translate value="pkg_type" />,
        resizable: true,
        width: 50,
        sortable: true,
      },
      {
        key: 'OrderQuantity',
        name: <Translate value="order_qty" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: 'OrderTotalNetWeight',
        name: <Translate value="order_wt" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: 'OrderUnitPrice',
        name: <span><Translate value="order_unit" /> ({this.state.currencyCode})</span>,
        resizable: true,
        width: 100,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: 'currency_unit',
        name: <Translate value="order_unit_dollarsign" />,
        resizable: true,
        width: 100,
        sortable: true,
      },
      {
        key: 'OrderTotalPrice',
        name: <span><Translate value="order_total" /> ({this.state.currencyCode})</span>,
        resizable: true,
        width: 100,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: 'currency_subtotal',
        name: <Translate value="order_total_dollarsign" />,
        resizable: true,
        width: 100,
        sortable: true,
      },
      ...isABBLE ? [{
        key: 'cbm',
        name: <Translate value="CBM" />,
        resizable: true,
        width: 70,
        sortable: true,
      }] : [{
          key: isPS ? 'dimension' : 'dimension_shipping',
          name: isPS ? 'DIM (in)' : <Translate value="package_dimension_shipping" />,
          resizable: true,
          width: 95,
          sortable: true,
      }],
      {
        key: 'weight_shipping',
        name: <Translate value="package_weight_shipping" />,
        resizable: true,
        width: 95,
        sortable: true,
      },
      {
        key: 'ReceiveQuantity',
        name: <Translate value="receive_qty" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: 'ReceiveTotalWeight',
        name: <Translate value="receive_wt" />,
        resizable: true,
        width: 70,
        sortable: true,
      },
      {
        key: 'ReceiveUnitPrice',
        name: <Translate value="receive_unit_dollarsign" />,
        resizable: true,
        width: 70,
        sortable: true,
        formatter: CashFormatter,
      },
      {
        key: 'ReceiveTotalPrice',
        name: <Translate value="receive_total_dollarsign" />,
        resizable: true,
        width: 80,
        sortable: true,
        formatter: CashFormatter,
      },
    ]

    if (isTN) {
      columns = (!this.state.currencyCode || this.state.currencyCode === 'USD')
      ?
      [
        {
          key: 'ProductNum',
          name: <Translate value="product_num" />,
          resizable: true,
          sortable: true,
          width: 100,
        },
        {
          key: 'RefNum',
          name: <Translate value="sku" />,
          resizable: true,
          sortable: true,
          width: 70,
        },
        {
          key: 'VendorProductNum',
          name: <Translate value="vendor_product_number" />,
          resizable: true,
          sortable: true,
          width: 150,
        },
        {
          key: 'Name',
          name: <Translate value="product_name" />,
          resizable: true,
          sortable: true,
          width: 250,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: 200,
        },
        {
          key: 'expire_date',
          name: <Translate value="expire_date" />,
          resizable: true,
          sortable: true,
          width: 80,
        },
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          width: 50,
          sortable: true,
        },
        {
          key: 'OrderQuantity',
          name: <Translate value="order_qty" />,
          resizable: true,
          width: 70,
          sortable: true,
        },
        {
          key: "total_box",
          name: <Translate value="total_box" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: "pc_box",
          name: <Translate value="pc_box" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: "pack",
          name: <Translate value="pack" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'OrderTotalNetWeight',
          name: <Translate value="order_wt" />,
          resizable: true,
          width: 70,
          sortable: true,
        },
        {
          key: isPS ? 'dimension' : 'dimension_shipping',
          name: isPS ? 'DIM (in)' : <Translate value="package_dimension_shipping" />,
          resizable: true,
          width: 95,
          sortable: true,
        },
        {
          key: 'weight_shipping',
          name: <Translate value="package_weight_shipping" />,
          resizable: true,
          width: 95,
          sortable: true,
        },
        {
          key: 'ReceiveQuantity',
          name: <Translate value="receive_qty" />,
          resizable: true,
          width: 70,
          sortable: true,
        },
        {
          key: 'ReceiveTotalWeight',
          name: <Translate value="receive_wt" />,
          resizable: true,
          width: 70,
          sortable: true,
        },
      ]
      :
      [
        {
          key: 'ProductNum',
          name: <Translate value="product_num" />,
          resizable: true,
          sortable: true,
          width: 100,
        },
        {
          key: 'RefNum',
          name: <Translate value="sku" />,
          resizable: true,
          sortable: true,
          width: 70,
        },
        {
          key: 'Name',
          name: <Translate value="product_name" />,
          resizable: true,
          sortable: true,
          width: 250,
        },
        {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: 200,
        },
        {
          key: 'expire_date',
          name: <Translate value="expire_date" />,
          resizable: true,
          sortable: true,
          width: 80,
        },
        {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          width: 50,
          sortable: true,
        },
        {
          key: 'OrderQuantity',
          name: <Translate value="order_qty" />,
          resizable: true,
          width: 70,
          sortable: true,
        },
        {
          key: "total_box",
          name: <Translate value="total_box" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: "pc_box",
          name: <Translate value="pc_box" />,
          resizable: true,
          sortable: true,
          width: 100,
          filterable: true,
        },
        {
          key: "pack",
          name: <Translate value="pack" />,
          resizable: true,
          sortable: true,
          width: 80,
          filterable: true,
        },
        {
          key: 'OrderTotalNetWeight',
          name: <Translate value="order_wt" />,
          resizable: true,
          width: 70,
          sortable: true,
        },
        {
          key: 'currency_unit',
          name: <Translate value="order_unit_dollarsign" />,
          resizable: true,
          width: 100,
          sortable: true,
        },
        {
          key: 'currency_subtotal',
          name: <Translate value="order_total_dollarsign" />,
          resizable: true,
          width: 100,
          sortable: true,
        },
        {
          key: isPS ? 'dimension' : 'dimension_shipping',
          name: isPS ? 'DIM (in)' : <Translate value="package_dimension_shipping" />,
          resizable: true,
          width: 95,
          sortable: true,
        },
        {
          key: 'weight_shipping',
          name: <Translate value="package_weight_shipping" />,
          resizable: true,
          width: 95,
          sortable: true,
        },
        {
          key: 'ReceiveQuantity',
          name: <Translate value="receive_qty" />,
          resizable: true,
          width: 70,
          sortable: true,
        },
        {
          key: 'ReceiveTotalWeight',
          name: <Translate value="receive_wt" />,
          resizable: true,
          width: 70,
          sortable: true,
        },
      ]
    }

    if (isPS) {
      const indexWT = _.findIndex(columns, { key: "weight_shipping" });
      const cmCol = {
        key: "dimension_cm",
        name: "DIM (cm)",
        resizable: true,
        width: 95,
        sortable: true,
      };
      const mmCol = {
        key: "dimension_mm",
        name: "DIM (mm)",
        resizable: true,
        width: 95,
        sortable: true,
      };
      columns.splice(indexWT, 0, cmCol, mmCol);
    }

    if(isOCM) {
      const download = {
        key: 'PurchaseOrderLine_id',
        name: <Translate value="download" />,
        resizable: true,
        sortable: true,
        width: 100,
        getRowMetaData: row => row,
        formatter: (props) => {
          const token = localStorage.getItem('token');
          const url = `${ROOT_URL}v1/purchase/order/print_label/${props.dependentValues.purchase_order_id}/${props.value}?Bearer=${token}`
          return <a
            href={url}
            style={{
            textDecoration: 'underline'
          }}>Download</a>
        }
      };
      const ProductNumIndex = _.findIndex(columns, { key: 'ProductNum' });
      columns.splice(ProductNumIndex + 1, 0, download);
    }

    if (isSH || isAP) {
      const orderQtyIndex = columns.findIndex(item => item.key === 'OrderQuantity');
      if (orderQtyIndex !== -1) {
        columns.splice(orderQtyIndex, 0, {
          key: 'purchase_convert_unit',
          name: <Translate value="convert_quantity" />,
          resizable: true,
          width: 90,
          sortable: true,
        });
      }
    }

    // React Table Purchase Order Details
    return (
      <Row>
        <Col xs={12}>
          <div className="recat-customizer" id="PurchaseOrderList-dataGrid2">
            <ReactDataGrid
              headerRowHeight={45}
              onGridSort={handleGridSort}
              onAddFilter={handleFilterChange}
              onClearFilters={onClearFilters}
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowHeight={25}
              minHeight={tableHeight}
              onRowUpdated={this.handleRowUpdated}
              onRowSelect={onRowSelect}
            />
          </div>
        </Col>
      </Row>
    );
  }

  IFrameIsLoaded = () => {
    if (!this.state.PdfFrameLoaded) {
      const pdfFrame = window.frames.purchaseOrderPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ PdfFrameLoaded: true });
    }
  };

  IFrameIsLoadedNs = () => {
    if (!this.state.PdfFrameLoadedNs) {
      const pdfFrame = window.frames.purchaseOrderPdfNs;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ PdfFrameLoadedNs: true });
    }
  }

  commercialInvoiceIFrameIsLoaded = () => {
    if (!this.state.commercialInvoicePdfFrameLoaded) {
      const pdfFrame = window.frames.commercialInvoicePdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ commercialInvoicePdfFrameLoaded: true });
    }
  }

  packingListIFrameIsLoaded = () => {
    if (!this.state.packingListPdfFrameLoaded) {
      const pdfFrame = window.frames.packingListPdf;
      pdfFrame.focus();
      pdfFrame.print();
      this.setState({ packingListPdfFrameLoaded: true });
    }
  }

  renderIFrame() {
    if (this.props.purchaseOrderPdf) {
      const file = window.URL.createObjectURL(this.props.purchaseOrderPdf);
      return <iframe style={{ display: 'none' }} onLoad={this.IFrameIsLoaded} id="purchaseOrderPdf" name="purchaseOrderPdf" src={file} />;
    }
    return null;
  }

  renderIFrameNs() {
    if (this.props.purchaseOrderPdfNs) {
      const file = window.URL.createObjectURL(this.props.purchaseOrderPdfNs);
      return <iframe style={{ display: 'none' }} onLoad={this.IFrameIsLoadedNs} id="purchaseOrderPdfNs" name="purchaseOrderPdfNs" src={file} />;
    }
    return null;
  }

  renderCommercialInvoiceIFrame = () => {
    if (this.props.commercialInvoicePdf) {
      const file = window.URL.createObjectURL(this.props.commercialInvoicePdf);
      return <iframe style={{ display: 'none' }} onLoad={this.commercialInvoiceIFrameIsLoaded} id="commercialInvoicePdf" name="commercialInvoicePdf" src={file} />;
    }
    return null;
  }

  renderPackingListIFrame = () => {
    if (this.props.packingListPdf) {
      const file = window.URL.createObjectURL(this.props.packingListPdf);
      return <iframe style={{ display: 'none' }} onLoad={this.packingListIFrameIsLoaded} id="packingListPdf" name="packingListPdf" src={file} />;
    }
    return null;
  }

  renderPrint() {
    const purchaseOrder_id = this.state.selectedRows && this.state.selectedRows.length === 1 && this.state.selectedRows[0].PurchaseOrder_id;
    return (
      <Button
        bsStyle="primary"
        className="btn btn-primary marginLeftStyle"
        disabled={this.props.requestingPurchaseOrderPdf || !purchaseOrder_id || !checkPermission('print_purchase_order')}
        type="button"
        onClick={() => {
          this.props.printPurchaseOrder(purchaseOrder_id);
        }}
      >
        <em className="fa fa-print" />
        <Translate value="print_po" />
      </Button>
    );
  }

  renderPrintNs() {
    const purchaseOrder_id = this.state.selectedRows && this.state.selectedRows.length === 1 && this.state.selectedRows[0].PurchaseOrder_id;
    return (
      <Button
      bsStyle="primary"
      className=" btn btn-primary marginLeftStyle"
      disabled={this.props.requestingPurchaseOrderPdfNs || !purchaseOrder_id || !checkPermission('print_purchase_order')}
      onClick={() => {
        this.props.printPurchaseOrderNoSubtotals(purchaseOrder_id);
      }}
      >
        <em className="fa fa-print" />
        <Translate value="print_ns"/>
      </Button>
      )
  }

  renderPrintCommercialInvoice = () => {
    const disabled = !checkPermission('print_purchase_order') || this.props.requestingCommercialInvoicePdf || this.state.selectedRows.length === 0
    return (
      <Button
        bsStyle="primary"
        className="btn btn-primary marginLeftStyle"
        disabled={disabled}
        type="button"
        onClick={() => {
          this.setState({
            showTotalBoxesPrintDialog: true,
            totalBoxesDialogType: 'commercialInvoice'
          })
        }}
      >
        <em className="fa fa-print" />
        <Translate value="print_commercial_invoice" />
      </Button>
    );
  }

  renderPrintPackingList = () => {
    const disabled = !checkPermission('print_purchase_order') || this.props.requestingPackingListPdf || this.state.selectedRows.length === 0
    return (
      <Button
        bsStyle="primary"
        className="btn btn-primary marginLeftStyle"
        disabled={disabled}
        type="button"
        onClick={() => {
          this.setState({
            showTotalBoxesPrintDialog: true,
            totalBoxesDialogType: 'packingList'
          })
        }}
      >
        <em className="fa fa-print" />
        <Translate value="print_packing_list" />
      </Button>
    );
  }

  renderDuplicate() {
    // const purchaseOrder_id = this.state.selectedRows && this.state.selectedRows.length === 1 && this.state.selectedRows[0].PurchaseOrder_id;
    const purchaseOrder_num = this.state.selectedRows && this.state.selectedRows.length === 1 && this.state.selectedRows[0].PONum;

    return (
      <Button
      bsStyle="success"
      className=" btn btn-primary marginLeftStyle"
      disabled={!purchaseOrder_num}
      onClick={() => {
        axios.post(
          `${ROOT_URL}v1/purchase/copy_po/${purchaseOrder_num}`,
          null,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                "token"
              )}`,
            },
          },
        )
        .then(
          (res) => {
            alert("Duplicate PO Successful");
            this.refreshList();
          },
          (err) => {
            // this.refreshList();
            if (err.data) {
              alert(err.data);
            } else {
              alert("Server issue detected, please contact admin.");
            }
          }
        );
      }}
      >
        <em className="fa fa-plus" />
        <Translate value="duplicate"/>
      </Button>
      )
  }

  renderExportButton() {
    const { FromDate, ToDate } = this.state;
    const Days = this.state.days;
    const status = this.state.Status === 'all' ? '' : `&PurchaseStatus=${this.state.Status}`;
    const dateRange = Days || -1;
    const { fromDate, toDate } = toFromDates(dateRange, FromDate, ToDate);

    const exportUrl = `${ROOT_URL}v1/purchase/search/export/?IsRelocation=false&OrderDate__gte=${fromDate}&OrderDate__lte=${toDate}${status}&Bearer=${localStorage.getItem('token')}`;

    // const buttonShouldDisable =

    return (
      <Button bsStyle="success" className="export-to-excel" href={exportUrl} disabled={!checkPermission('print_purchase_order')}>
        <em className="fa fa-download" />
        <Translate value="excel" />
      </Button>
    );
  }

  renderExportOpenButton() {
    const { FromDate, ToDate } = this.state;
    const Days = this.state.days;
    const status = this.state.Status === 'all' ? '' : `&PurchaseStatus=${this.state.Status}`;
    const dateRange = Days || -1;
    const { fromDate, toDate } = toFromDates(dateRange, FromDate, ToDate);

    const exportOpenUrl = `${ROOT_URL}v1/purchase/search/export_open/?IsRelocation=false&OrderDate__gte=${fromDate}&OrderDate__lte=${toDate}&Bearer=${localStorage.getItem('token')}`;

    // const buttonShouldDisable =

    return (
      <Button bsStyle="success" className="export-to-excel" href={exportOpenUrl} disabled={!checkPermission('print_purchase_order')}>
        <em className="fa fa-download" />
        <Translate value="excel_open" />
      </Button>
    );
  }

  setMergePOModalVsibility = (isMergePOModalVisible = false) => this.setState({ isMergePOModalVisible });
  handleMergePoSuccess = () => {
    this.refreshList(true);
    this.setMergePOModalVsibility();
  }
  setSplitPOModalVisibility = (isSplitPOModalVisible = false) => this.setState({ isSplitPOModalVisible });
  handleSplitPOSuccess = () => {
    this.refreshList(true);
    this.setSplitPOModalVisibility();
  }

  renderMergePOButton = () => {
    if (!isOCM) return null;
    const { rows, selectedRows } = this.state;
    return (
      <Button bsStyle="primary" disabled={selectedRows.length < 2} onClick={() => this.setMergePOModalVsibility(true)}>
        {/* <em className="fa fa-merge" /> */}
        <Translate value="merge_po" />
      </Button>
    );
  }
  renderSplitePOButton = () => {
    if (!isOCM) return null;
    const { rows, selectedRows } = this.state;
    return (
      <Button bsStyle="primary" disabled={selectedRows.length !== 1} onClick={() => this.setSplitPOModalVisibility(true)}>
        {/* <em className="fa fa-merge" /> */}
        <Translate value="split_po" />
      </Button>
    )
  }

  renderExportSelectedButton() {
    const purchaseOrderIds = [];
    const { selectedRows } = this.state;
    if (selectedRows && selectedRows.length > 0) {
      selectedRows.map((row) => {
        purchaseOrderIds.push(row.PurchaseOrder_id);
      });
    }
    const exportUrl = `${ROOT_URL}v2/po-line-export/${purchaseOrderIds.join(",")}?Bearer=${localStorage.getItem("token")}`
    return (
      <Button bsStyle="success" className="export-to-excel" href={exportUrl} disabled={(!purchaseOrderIds || purchaseOrderIds.length < 1)}>
        <em className="fa fa-download" />
        <Translate value="excel_lines" />
      </Button>
    );
  }

  mergeAndRedirect = () => {
    const { orderIds } = this.state;
    this.props.mergePurchaseOrders(orderIds);
  }

  openMergeRequest = () => {
    this.setState({
      mergeModalOpen: true
    });
  }

  cancelMergeRequest = () => {
    this.setState({
      mergeModalOpen: false
    })
  }

  mergePurchaseRows = () => {
    const { selectedRows } = this.state;
    let validMerge = true;
    let orderIds = [];
    if (selectedRows && selectedRows.length) {
      selectedRows.map(row => {
        let r = row;
        if (r.PurchaseStatus === 'Pending' || r.PurchaseStatus === 'Open') {
        validMerge = false;
        } else {
          orderIds.push(r.PurchaseOrder_id)
        }
      });
      this.setState({
        orderIds,
        validMerge
      });
    }
  }

  renderMergeButton() {
    const { validMerge, orderIds, selectedRows } = this.state;
    return (
      <Button
        bsStyle="primary"
        disabled={!validMerge || orderIds.length === 0 || selectedRows.length < 2}
        onClick={this.openMergeRequest}
      >
        <em class="fa fa-compress" />
        <Translate value="merge" />
      </Button>
    )
  }

  openTrackingNoteModal = () => {
    this.setState({ showTrackingNoteModal: true });
  }

  closeTrackingNoteModal = () => {
    this.setState({ showTrackingNoteModal: false });
  }

  checkTrackingNoteDisable() {
    const { selectedRows } = this.state;
    if (selectedRows === null || selectedRows.length !== 1) {
      return true;
    } else {
      return false;
    }
  }

  closeTotalBoxesPrintDialog = () => {
    this.setState({ showTotalBoxesPrintDialog: false, totalBoxesDialogType: null});
  }

  handleTotalBoxesPrint = totalBoxes => {
    if(this.state.totalBoxesDialogType === 'packingList') {
      this.printPackingList(totalBoxes);
    }
    if(this.state.totalBoxesDialogType === 'commercialInvoice') {
      this.printCommercialInvoice(totalBoxes);
    }
  }

  printCommercialInvoice = totalBoxes => {
    if(!totalBoxes) {
      alert('Total boxes cannot be blank');
      return false;
    }
    const ids = this.state.selectedRows.map(row => row.container_num);
    this.props.printCommercialInvoicePdf(ids, totalBoxes);
    this.closeTotalBoxesPrintDialog();
  }

  printPackingList = (totalBoxes) => {
    if(!totalBoxes) {
      alert('Total boxes cannot be blank') ;
      return false;
    }
    const ids = this.state.selectedRows.map(row => row.container_num);
    this.props.printPackingListPdf(ids, totalBoxes);
    this.closeTotalBoxesPrintDialog();
  }

  renderTrackingNote() {
    return (
      <Button
      bsStyle="success"
      type="button"
      disabled={this.checkTrackingNoteDisable()}
      onClick={this.openTrackingNoteModal}
      >
        <Translate value='tracking_note' />
      </Button>
    );
  }

  renderApprovePO() {
    const { selectedRows } = this.state;
    let onlyPending = true;
    if (selectedRows) {
      selectedRows.map(r => {
        if (r.PurchaseStatus !== 'Pending') {
          onlyPending = false;
        }
      });
    }
    return (
      <Button
        bsStyle="success"
        type="button"
        disabled={!selectedRows || selectedRows.length < 1 || onlyPending === false}
        onClick={() => {
        this.submitApprovePO(selectedRows);
      }}
      >
        <Translate value="approve" />
      </Button>
    );
  }

  renderSendEmailButton = () => {
    const { selectedRows } = this.state;
    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={selectedRows.length !== 1}
        type="button"
        onClick={() => {
          this.props.emailPO(selectedRows[0].PurchaseOrder_id);
        }}
      >
        <em className="fa fa-email" />
        <Translate value="email_po" />
      </Button>
    );
  }

  renderSendEmailButtonTemplate = () => {
    const { selectedRows } = this.state;
    // const salesOrder_id =
    //   this.state.selectedRows.length === 1 &&
    //   this.state.selectedRows[0].SalesOrder_id;

    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={selectedRows.length !== 1}
        type="button"
        onClick={() => {
          this.setState({
            emailSubjectTemplate: this.genSubjectTemplate(),
            emailContentTemplate: this.genContentTemplate(),
            emailContentModalVisibility: true
          })
        }}
      >
        <Translate value="email_po" />
      </Button>
    );
  }

  renderPOExportButton = () => {
    const { selectedRows } = this.state;
    const success = () => {
      // alert('success!');
      // this.refreshList();
    }
    const failed = (err = 'UNKNOWN') => {
      alert('failed', err);
    }
    const pks = selectedRows.map(r => r.id);

    return (
      <Button
        bsStyle="success"
        className="print-btn"
        disabled={!selectedRows.length}
        type="button"
        onClick={() => {
          // this.props.emailPO(selectedRows[0].PurchaseOrder_id);
          // alert('Truckxing is working hard to impelement this feature!!!')
          this.props.handlePoExportClick(pks, success, failed);
        }}
      >
        {/* <em className="fa fa-email" /> */}
        <Translate value="po_template" />
      </Button>
    );
  }

  renderPOUpload = () => {
    if (isABBLE) {
      const handleUpload = (platform, formData) => {
        const success = () => {
          alert('success');
          this.refreshList();
        }
        const failed = () => {
          alert('failed')
        }
        axios({
          method: 'post',
          url:  `${ROOT_URL}v2/abble_import_order?platform=${platform}`,
          data: formData,
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        })
        .then(res => {
          success();
        })
        .catch(err => {
          failed();
        })
      }
      return (
        <div>
          <input
            ref='hayneedle_po_upload_ref'
            type='file'
            name='hayneedle'
            id="hayneedle_po_upload_ref"
            onChange={(e) => {
              const files = e.target.files;
              const formData = new FormData();
              formData.append('FILE', files[0]);
              handleUpload('hayneedle', formData);
            }}
            style={{ display: 'none' }}
          />
          <input
            id="faire_po_upload_ref"
            ref='faire_po_upload_ref'
            type='file'
            name='faire'
            onChange={(e) => {
              const files = e.target.files;
              const formData = new FormData();
              formData.append('FILE', files[0]);
              handleUpload('faire', formData);
            }}
            style={{ display: 'none' }}
          />
          <DropdownButton
            bsStyle="success"
            // disabled={!this.props.currentSalesOrder}
            style={{ paddingLeft: '5px', marginLeft: '5px' }}
            className="upload_po"
            title={
              <span>
                <i className="fa fa-print" />
                <Translate value="upload_po" />
              </span>
            }
          >
            <MenuItem onClick={() => {
              this.refs.hayneedle_po_upload_ref.click();
            }}>
              <Translate value="hayneedle" />
            </MenuItem>
            <MenuItem onClick={() => {
              this.refs.faire_po_upload_ref.click();
            }}>
              <Translate value="faire" />
            </MenuItem>
        </DropdownButton>
        </div>
      )
    }

    const { selectedRows } = this.state;
    const success = () => {
      alert('success!');
      this.refreshList();
    }
    const failed = (err) => {
      if (err) {
        let mes = err.data || err;
        alert(JSON.stringify(mes));
        return;
      }
      alert('failed', err);
    }
    const pks = selectedRows.map(r => r.id);
    const onDrop = (files) => {
      const formData = new FormData();
      formData.append('FILE', files[0]);
      this.props.handlePOUpload(formData, success, failed, this.props.selectedCompany, this.props.selectedWarehouse);
    }
    return  (
      <Dropzone onDrop={onDrop} style={{ 'padding-left': '5px' }} className="upload-button">
        <Button
          bsStyle="success"
          className="print-btn"
          type="button"
          style={{ marginLeft: '5px' }}
        >
          {/* <em className="fa fa-email" /> */}
          <Translate value="upload_po" />
        </Button>
      </Dropzone>
    )
  }

  renderSetStatus = () => {
    const { selectedRows } = this.state;
    const success = () => {
      alert('success!');
      // this.refreshList();
    }
    const failed = (err) => {
      if (err) {
        let mes = err.data || err;
        alert(JSON.stringify(mes));
        return;
      }
      alert('failed', err);
    }

    return  (
      <DropdownButton
        className="status-dropdown"
        bsStyle="success"
        title={ <span> <Translate value="reset_status" /> </span> }
        disabled={
          !this.state.selectedRows ||
          this.state.selectedRows.length !== 1  ||
          this.state.selectedRows[0].order_status !== 'open'
        }
      >
        <MenuItem>
          <Button
            bsStyle="primary"
            className="btn btn-primary"
            type="button"
            onClick={() => { this.props.resetStatus('factory', this.state.selectedRows[0].id,  success, failed); }}
          >
            <Translate value="factory" />
          </Button>
        </MenuItem>
        <MenuItem>
          <Button
            bsStyle="primary"
            className="btn btn-primary"
            type="button"
            onClick={() => { this.props.resetStatus('port', this.state.selectedRows[0].id,  success, failed); }}
          >
            <Translate value="port" />
          </Button>
        </MenuItem>
        <MenuItem>
          <Button
            bsStyle="primary"
            className="btn btn-primary"
            type="button"
            onClick={() => { this.props.resetStatus('truck', this.state.selectedRows[0].id,  success, failed); }}
          >
            <Translate value="truck" />
          </Button>
        </MenuItem>
      </DropdownButton>
    )
  }

  setConvertToSOModalVisibility = (isConvertToSOModalVisible = false) => this.setState({ isConvertToSOModalVisible });

  renderOCMButtons = () => {
    if (!isOCM) {
      return null;
    }

    let type = {
      IsRelocation: false,
      IsTransfer: false,
    };
    if (this.state.Type) {
      type[this.state.Type] = true;
    }

    const { FromDate, ToDate, days, Type, selectedRows } = this.state;
    const Days = days || -1;
    const {
      fromDate, toDate
    } = toFromDates(Days, FromDate, ToDate);
    const dateRangeParam = `&OrderDate__gte=${fromDate}&OrderDate__lte=${toDate}`;
    let orderTypeParam = '';
    if (Type) {
      orderTypeParam = `&${Type}=true`
    } else {
      orderTypeParam = `&IsTransfer=false&IsRelocation=false`;
    }
    if (isSV) {
      orderTypeParam = '';
    }
    const multi = `&Company_id=${this.props.selectedCompany && this.props.selectedCompany.value}&warehouse_id=${this.props.selectedWarehouse && this.props.selectedWarehouse.value}`;

    const poExportUrl = `${ROOT_URL}v1/purchase/export_po_lines?${dateRangeParam}${orderTypeParam}${multi}&Bearer=${localStorage.getItem('token')}`
    let linesExportUrl = 'javascript:;'
    if (selectedRows.length !== 0) {
      const pks = selectedRows.map(r => r.id);
      linesExportUrl = `${ROOT_URL}v1/purchase/export_po_line?pk=${pks.join(',')}&Bearer=${localStorage.getItem('token')}`
    }
    return(
      <div className="table-filters" style={{zIndex: 1, position: 'relative', padding: '5px 0px'}}>
        <ButtonToolbar className="table-buttons">
          <Button
            bsStyle="success"
            href={poExportUrl}
          >
            <Translate value="po_export" />
          </Button>
          <Button
            bsStyle="success"
            disabled={selectedRows.length !== 1}
            onClick={() => {
              this.setConvertToSOModalVisibility(true);
            }}
          >
            <Translate value="convert_to_so" />
          </Button>
          <Button
            bsStyle="success"
            disabled={selectedRows.length === 0}
            href={linesExportUrl}
          >
            <Translate value="export_po_lines" />
          </Button>
        </ButtonToolbar>
      </div>
    )
  }

  renderExportPoSV = () => {
    let type = {
      IsRelocation: false,
      IsTransfer: false,
    };
    if (this.state.Type) {
      type[this.state.Type] = true;
    }

    const { FromDate, ToDate, days, Type, selectedRows } = this.state;
    const Days = days || -1;
    const {
      fromDate, toDate
    } = toFromDates(Days, FromDate, ToDate);
    const dateRangeParam = `&OrderDate__gte=${fromDate}&OrderDate__lte=${toDate}`;
    let orderTypeParam = '';
    if (Type) {
      orderTypeParam = `&${Type}=true`
    } else {
      orderTypeParam = `&IsTransfer=false&IsRelocation=false`;
    }
    if (isSV) {
      orderTypeParam = '';
    }
    const multi = `&Company_id=${this.props.selectedCompany && this.props.selectedCompany.value}&warehouse_id=${this.props.selectedWarehouse && this.props.selectedWarehouse.value}`;

    const poExportUrl = `${ROOT_URL}v1/purchase/export_po_lines?${dateRangeParam}${orderTypeParam}${multi}&Bearer=${localStorage.getItem('token')}`
    let linesExportUrl = 'javascript:;'
    if (selectedRows.length !== 0) {
      const pks = selectedRows.map(r => r.id);
      linesExportUrl = `${ROOT_URL}v1/purchase/export_po_line?pk=${pks.join(',')}&Bearer=${localStorage.getItem('token')}`
    }
    return(
      <div className="table-filters" style={{zIndex: 1, position: 'relative', padding: '5px 0px'}}>
        <ButtonToolbar className="table-buttons">
          <Button
            bsStyle="success"
            href={poExportUrl}
          >
            PO Export
          </Button>
          <Button
            bsStyle="success"
            disabled={selectedRows.length === 0}
            href={linesExportUrl}
          >
            PO Export Lines
          </Button>
        </ButtonToolbar>
      </div>
    )
  }

  renderAutoSuggest() {
    if (!this.state.filteredByItem) {
      return (
        <div className="control-dropdown">
          <GenericProductSuggest
            value={this.state.suggestValue}
            onChange={(e, { newValue }) => {
              this.setState({ suggestValue: newValue });
            }}
            SearchType={this.state.productSearchType}
            fetchOrdersByProduct={this.fetchPurchaseOrdersByProduct}
          />
        </div>
      );
    }
    return (
      <div className="control-dropdown" id="suggestion-box">
        {this.state.suggestValue}
        <em
          className="fa fa-times pull-right"
          onClick={() => {
            this.setState({ filteredByItem: false, suggestValue: '', filterProductID: null }, () => {
              this.fetchPurchaseOrdersByDetails(this.state.days);
            });
          }}
        />
      </div>
    );
  }

  searchPO = (order_num) => {
    this.refreshList();
  }

  searchPOByBoln = () => {
    let { selectedRows } = this.state;
    let newRows = this.state.rows;
    const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
    const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
    let { days } = this.state;
    if (days == null) {
      days = 7;
    }
    let purchaser = this.props.Purchaser;
    if (this.props.Purchaser) {
      purchaser = this.props.Purchaser.value;
    }
    const productNum = this.props.ProductNum;
    if (isOCM) {
      this.state.currentPage = 0;
    }
    this.props.fetchPurchaseOrdersByFilter(
      this.context.router.routes[1].path,
      fromDate,
      toDate,
      days,
      this.state.Status,
      purchaser,
      productNum,
      this.state.Type,
      null,
      this.state.productSearchType,
      this.state.suggestValue,
      undefined,
      this.state.limit,
      this.state.currentPage,
      this.getFilterParams(),
    );

    setTimeout(() => {
      newRows = this.state.rows;
      if (newRows) {
        newRows.map((r, i)=>{
          selectedRows.map((s, j)=>{
            if (r.id === s.id) {
              selectedRows[j] = r;
              newRows[i].isSelected = true;
            }
          });
        });
      }
      this.setState({ ...this.state, selectedRows, rows: newRows});
    }, 1000);
  }

  searchPOByLoadingPort = () => {
    let { selectedRows } = this.state;
    let newRows = this.state.rows;
    const fromDate = this.state.FromDate ? this.formatDate(this.state.FromDate) : '1900-01-01';
    const toDate = this.state.ToDate ? this.formatDate(this.state.ToDate) : '3000-01-01';
    let { days } = this.state;
    if (days == null) {
      days = 7;
    }
    let purchaser = this.props.Purchaser;
    if (this.props.Purchaser) {
      purchaser = this.props.Purchaser.value;
    }
    const productNum = this.props.ProductNum;
    if (isOCM) {
      this.state.currentPage = 0;
    }
   this.props.fetchPurchaseOrdersByFilter(
     this.context.router.routes[1].path,
     fromDate,
     toDate,
     days,
     this.state.Status,
     purchaser,
     productNum,
     this.state.Type,
     null,
     this.state.productSearchType,
     null,
     this.state.suggestValue,
     this.state.limit,
     this.state.currentPage,
     this.getFilterParams(),
   );

    setTimeout(() => {
      newRows = this.state.rows;
      if (newRows) {
        newRows.map((r, i)=>{
          selectedRows.map((s, j)=>{
            if (r.id === s.id) {
              selectedRows[j] = r;
              newRows[i].isSelected = true;
            }
          });
        });
      }
      this.setState({ ...this.state, selectedRows, rows: newRows});
    }, 1000);
  }

  renderPONoSearchInput = () => {
    return (
      <input
        placeholder="Purchase No."
        value={this.state.suggestValue}
        onChange={(e) =>
          this.setState({
            suggestValue: e.target.value,
          })
        }
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            this.searchPO(this.state.suggestValue);
          }
        }}
        style={{
          outline: "none",
          width: "100%",
          height: "24px",
          padding: "10px 10px",
          fontFamily: "Helvetica, sans-serif",
          fontWeight: "300",
          fontSize: "12px",
          border: "1px solid #aaa",
          borderRadius: "4px",
        }}
      />
    );
  };

  renderContainerNumSearchInput = () => {
    return (
      <input
        placeholder={I18n.t('Container Num.')}
        value={this.state.suggestValue}
        onChange={(e) =>
          this.setState({
            suggestValue: e.target.value,
          })
        }
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            this.refreshList();
          }
        }}
        style={{
          outline: "none",
          width: "100%",
          height: "24px",
          padding: "10px 10px",
          fontFamily: "Helvetica, sans-serif",
          fontWeight: "300",
          fontSize: "12px",
          border: "1px solid #aaa",
          borderRadius: "4px",
        }}
      />
    );
  };

  renderBolnSearchInput = () => {
    return (
      <input
        placeholder="Bill of Lading No."
        value={this.state.suggestValue}
        onChange={(e) =>
          this.setState({
            suggestValue: e.target.value,
          })
        }
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            this.searchPOByBoln(this.state.suggestValue);
          }
        }}
        style={{
          outline: "none",
          width: "100%",
          height: "24px",
          padding: "10px 10px",
          fontFamily: "Helvetica, sans-serif",
          fontWeight: "300",
          fontSize: "12px",
          border: "1px solid #aaa",
          borderRadius: "4px",
        }}
      />
    );
  }

  renderLoadingPortSearchInput = () => {
    return (
      <input
        placeholder="Loading Port"
        value={this.state.suggestValue}
        onChange={(e) =>
          this.setState({
            suggestValue: e.target.value,
          })
        }
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            this.searchPOByLoadingPort(this.state.suggestValue);
          }
        }}
        style={{
          outline: "none",
          width: "100%",
          height: "24px",
          padding: "10px 10px",
          fontFamily: "Helvetica, sans-serif",
          fontWeight: "300",
          fontSize: "12px",
          border: "1px solid #aaa",
          borderRadius: "4px",
        }}
      />
    );
  }

  renderOrderTypeRadio = () => {

    let config = {
      content: ((isEKC || isLMH || isBRO || isSDR || isCRW || isSC) && (this.context.router.routes[1].path === "dropshipOrder")) ? [
        {
          option: 'Open',
          id: 'open-radio-filter',
          name: 'typeFilterRadios',
          labelName: 'Pending',
        },
        {
          option: 'Complete',
          id: 'complete-radio-filter',
          name: 'typeFilterRadios',
          labelName: 'Ordered',
        },
      ] : [
        {
          option: null,
          id: 'all-radio-filter',
          name: 'typeFilterRadios',
          labelName: 'normal',
        },
        {
          option: 'IsRelocation',
          id: 'relocate-radio-filter',
          name: 'typeFilterRadios',
          labelName: 'relocated',
        },
      ],
      value: this.state.Type,
      handleOnClick: this.handleTypeFilterChange,
      type: 'buttons',
    }

    if (isOCM) {
      config.content.push({
        option: 'IsTransfer',
        id: 'transfer-radio-filter',
        name: 'typeFilterRadios',
        labelName: 'transfer',
      })
    }

    return (
      genericRadioFilter(config)
    )
  }

  renderSearchInput = () => {
    if (this.state.productSearchType === 'order_num') {
      return <Col xs={12}>{this.renderPONoSearchInput()}</Col>
    }
    if (this.state.productSearchType === 'container_num') {
      return <Col xs={12}>{this.renderContainerNumSearchInput()}</Col>
    }
    if (this.state.productSearchType === 'boln') {
      return <Col xs={12}>{this.renderBolnSearchInput()}</Col>
    }
    if (this.state.productSearchType === 'LoadingPort') {
      return <Col xs={12}>{this.renderLoadingPortSearchInput()}</Col>
    }
    return <Col xs={12}>{this.renderAutoSuggest()}</Col>
  }

  render() {
    const createDialogStyle = {
      width: '550px',
      height: '300px',
      marginLeft: '-15%',
    };
    const createTrackingNoteStyle = {
      width: '1000px',
      height: '500px',
      // marginLeft: '-15%',
    };
    const trackingNoteTitle = (<Translate value="tracking_note" />);
    const packingListDialogTitle = <Translate value="print_packing_list_dialog"/>
    const { selectedRows } = this.state;
    let purchaseOrder_id = this.state.selectedRows && this.state.selectedRows[0] && this.state.selectedRows[0].PurchaseOrder_id;
    purchaseOrder_id = purchaseOrder_id || '';
    return (
      //---------------
      // Begin HTML
      //---------------
      <ContentWrapper>
        {/* Nav Trail */}
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="purchase_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value={(this.context.router.routes[1].path !== "dropshipOrder") ? "purchase_order" : "dropship_order"} />
          </Breadcrumb.Item>
        </Breadcrumb>
        {/* End Nav Trail */}
        <Grid id="purchase-order-list">
          {/* Date Range Pickers */}
          <Row>
            <Col xs={12}>
              <Panel id="date-range-picker" className="form-horizontal">
                <Row>
                {/* {
                    (this.context.router.routes[1].path !== "dropshipOrder") && */}
                  <Col xs={2}>
                    <h3 className="filter-title">
                      <Translate value="order_type" />
                      <span className="colon">:</span>
                    </h3>
                  </Col>
                  {/*
                  {
                        (this.context.router.routes[1].path !== "dropshipOrder") && */}
                  <Col xs={10}>
                    <div id="statusFilterRadios" className="form-horizontal">
                      {this.renderOrderTypeRadio()}
                    </div>
                  </Col>
                  {/* } */}
                  <Col xs={2}>
                    <h3 className="filter-title">
                      <Translate value="order_status" />
                      <span className="colon">:</span>
                    </h3>
                  </Col>
                  <Col xs={10}>
                    <div id="statusFilterRadios" className="form-horizontal">
                      {genericRadioFilter({
                        content: [
                          {
                            option: 'all',
                            id: 'all-radio-filter',
                            name: 'statusFilterRadios',
                            labelName: 'all',
                          },
                          {
                            option: 'Placed',
                            id: 'placed-radio-filter',
                            name: 'statusFilterRadios',
                            labelName: 'placed',
                          },
                          ...isABBLE ? [{
                            option: 'Departed',
                            id: 'departed-radio-filter',
                            name: 'statusFilterRadios',
                            labelName: 'departed',
                          }] : [],
                          ...isHMM ? [{
                            option: 'Factory',
                            id: 'factory-radio-filter',
                            name: 'statusFilterRadios',
                            labelName: 'factory',
                          }, {
                            option: 'Port',
                            id: 'port-radio-filter',
                            name: 'statusFilterRadios',
                            labelName: 'port',
                          }, {
                            option: 'Truck',
                            id: 'truck-radio-filter',
                            name: 'statusFilterRadios',
                            labelName: 'truck',
                          }] : [],
                          {
                            option: 'Received',
                            id: 'received-radio-filter',
                            name: 'statusFilterRadios',
                            labelName: 'received',
                          },
                          {
                            option: 'Partially Received',
                            id: 'partial-received-radio-filter',
                            name: 'statusFilterRadios',
                            labelName: 'partial',
                          },
                          {
                            option: 'Canceled',
                            id: 'canceled-received-radio-filter',
                            name: 'statusFilterRadios',
                            labelName: 'canceled',
                          },
                        ],
                        value: this.state.Status,
                        handleOnClick: this.handleStatusFilterChange,
                        type: 'buttons',
                      })}
                    </div>
                  </Col>
                  <Col xs={2}>
                    <h3 className="filter-title">
                      <Translate value="order_date" />
                      <span className="colon">:</span>
                    </h3>
                  </Col>
                  <Col xs={10}>
                    {dateFilterRadios({
                      handleOnClick: this.fetchPurchaseOrdersByDetails,
                      setToRangeSearch: this.setToRangeSearch,
                      setFromDate: this.setFromDate,
                      setToDate: this.setToDate,
                      FromDate: this.state.FromDate,
                      ToDate: this.state.ToDate,
                      Days: this.state.days,
                    })}
                  </Col>
                </Row>
              </Panel>
            </Col>
          </Row>
          {/* Purchase Order List */}
          <Row>
            <Col xs={12}>
              <Panel
                className="position-relative table-collapse-fix"
                id={isOCM ? 'table-collapse-fix-450' : ''}>
                <div style={{ position: 'relative' }}>
                  <ButtonToolbar className="table-buttons">
                    <Button
                      bsStyle="success"
                      type="submit"
                      href="/glform/new"
                      // onClick={(event) => { this.clickNew(event); }}
                      disabled={!checkPermission('add_purchase_order')}
                    >
                      <em className="fa fa-plus" />
                      <Translate value="create" />
                    </Button>
                    {
                      isTN && (
                        <Button
                          bsStyle="success"
                          // type="submit"
                          // href="/purchaseOrder/new"
                          onClick={(event) => {
                            this.refs.excelFileInputRef.click();
                          }}
                          disabled={!checkPermission('add_purchase_order')}
                        >
                          <em className="fa fa-plus" />
                          <Translate value="create_with_excel" />
                        </Button>
                      )
                    }
                    {
                      isTN && (
                        <input
                          type="file"
                          onChange={(e) => {
                            const formData = new FormData();
                            formData.append('FILE', e.target.files[0])
                            if (e.target.files[0]) {
                              axios.post(
                                `${ROOT_URL}v2/po-xls/`,
                                formData,
                                {
                                  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                                },
                              )
                              .then(res => {
                                // this.fetchPurchaseOrdersByDetails(this.state.days)
                                alert("PO Imported Successfully");
                                this.refreshList();
                              }, (err) => {
                                if (err.data) {
                                  alert(err.data);
                                } else {
                                  alert("Server issue detected, please contact admin.");
                                }
                              })
                            }
                          }}
                          ref="excelFileInputRef"
                          name=""
                          id=""
                          style={{ display: 'none' }}
                        />
                      )
                    }
                    <Button
                      bsStyle="warning"
                      type="button"
                      href={`/glform/${purchaseOrder_id}`}
                      // onClick={(event) => { this.setCurrentPurchaseOrder(event); }}
                      disabled={!this.state.selectedRows || this.state.selectedRows.length !== 1}
                    >
                      <em className="fa fa-pencil" />
                      <Translate value="edit" />
                    </Button>
                    <Button
                      bsStyle="danger"
                      type="reset"
                      onClick={() => {
                        this.openCheckAuthorize('void');
                      }}
                      disabled={this.shouldVoidButtonDisable() || !checkPermission('delete_purchase_order')}
                    >
                      <em className="fa fa-trash-o" />
                      <Translate value="void" />
                    </Button>
                    {this.renderPrint()}
                    {this.renderPrintNs()}
                    {isMMD && this.renderDuplicate()}
                    {this.renderExportButton()}
                    {isSV && this.renderExportOpenButton()}
                    {this.renderMergePOButton()}
                    {this.renderSplitePOButton()}
                    {/* {this.renderPOUpload()} */}
                  </ButtonToolbar>
                  <div className="table-filters" style={{ zIndex: 1 }}>
                    <label className="control-label">
                      <Translate value="select_purchaser" />
                    </label>
                    {this.renderUsers()}
                    <ButtonToolbar className="table-buttons">
                      {/* {this.renderExportButton()} */}
                      {(isTN || isAFG || isMMD) && this.renderExportSelectedButton()}
                      { isAFGRelated &&
                        this.renderMergeButton()
                      }
                      {/* { isJML && this.renderTrackingNote()} */}
                      {this.renderTrackingNote()}
                      {(isAFG || isMyuMyu || isMMD) && this.renderApprovePO()}
                      {(isOCM || isEKC || isLMH || isBRO || isSDR || isCRW || isSC) && this.renderSendEmailButton()}
                      {isSV && this.renderSendEmailButtonTemplate()}
                      {this.renderPOExportButton()}
                      {this.renderPOUpload()}
                      {isHMM && this.renderSetStatus()}
                    </ButtonToolbar>
                  </div>
                  {this.renderOCMButtons()}
                  {isSV && this.renderExportPoSV()}
                  {(isSH || isAP) && <div className="table-filters" style={{zIndex: 1, position: 'relative', padding: '5px 0px'}}>
                    <ButtonToolbar className="table-buttons">
                      {this.renderPrintCommercialInvoice()}
                      {this.renderPrintPackingList()}
                    </ButtonToolbar>
                  </div>}
                  <div id="autosuggest-div">
                    <Row style={{ height: '30px' }}>
                      <Col xs={6}>
                        <TypeRadios value={this.state.productSearchType} handleOptionChange={this.handleOptionChange} SalesOrderNoSearch BillOfLadingSearch={isSH || isAP} loadingPortSearch={isABBLE} containerNum={isOCM} />
                      </Col>
                      {/* <Col>
                        <span style={{ fontSize: '13px', fontWeight: 'bold', paddingLeft: '30px', paddingRight: '10px' }}><Translate value='relocated_order'/></span><input type='checkbox' checked={this.state.isSearchingRelocated} onChange={this.handleRelocatedSearchCheckClick}/>
                      </Col> */}
                    </Row>
                    <Row>
                      <Col xs={6}>
                        <Row>
                          {
                            this.renderSearchInput()
                          }
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </div>
                {/* Purchase Order Full Table */}
                {this.renderTable()}
              </Panel>
            </Col>
          </Row>
          {/* End Purchase Order List */}
          {/* Purchase Order Details */}
          <Row>
            <Col xs={12}>
              <h2>
                <Translate value={(this.context.router.routes[1].path !== "dropshipOrder") ? "purchase_order_details" : "dropship_order_details"} />
              </h2>
              <Panel className="details-table-collapse-fix">{this.renderProductsTable()}</Panel>
            </Col>
          </Row>
          {this.renderIFrame()}
          {this.renderIFrameNs()}
          {this.renderCommercialInvoiceIFrame()}
          {this.renderPackingListIFrame()}
        </Grid>
        <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.checkAuthorizeOpen} onCloseClicked={this.closeCheckAuthorize}>
          <ConfirmActionModal case="confirmPassword" closeC={this.checkAuthorize} checkPasswordFailure={this.props.checkPasswordFailure} />
        </SkyLightStateless>

        <SkyLightStateless
          dialogStyles={createTrackingNoteStyle}
          isVisible={this.state.showTrackingNoteModal}
          onCloseClicked={this.closeTrackingNoteModal}
          onOverlayClicked={this.closeTrackingNoteModal}
          title={trackingNoteTitle}
        >
          <TrackingNoteModal
            selectedOrder={selectedRows}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.showTotalBoxesPrintDialog}
          onCloseClicked={this.closeTotalBoxesPrintDialog}
          onOverlayClicked={this.closeTotalBoxesPrintDialog}
          title={packingListDialogTitle}
        >
          <ConfirmActionModal case="inputTotalBoxes" closeC={this.handleTotalBoxesPrint} />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          onCloseClicked={this.cancelMergeRequest}
          onOverlayClicked={this.cancelMergeRequest}
          isVisible={this.state.mergeModalOpen}
        >
          <Row className="centerStyle"><h4><Translate value="msg_confirm_merge_pos" /></h4></Row>
          <br /><br /><br/>
          <Row className="centerStyle">
            <Button bsStyle="primary" className="mr" onClick={this.mergeAndRedirect} type="button" ><Translate value="yes" /></Button>
            <Button bsStyle="danger" className="mr" onClick={ this.cancelMergeRequest} type="button" ><Translate value="no" /></Button>
          </Row>
        </SkyLightStateless>
        <MergePOModal
          isVisible={this.state.isMergePOModalVisible}
          onClose={this.setMergePOModalVsibility}
          onConfirm={this.setMergePOModalVsibility}
          selectedRows={this.state.selectedRows}
          handleMergePoSuccess={this.handleMergePoSuccess}
        />
        <SplitPOModal
          isVisible={this.state.isSplitPOModalVisible}
          onClose={this.setSplitPOModalVisibility}
          selectedRows={this.state.selectedRows}
          handleSplitPOSuccess={this.handleSplitPOSuccess}
        />
        <ConvertToSOModal
          isVisible={this.state.isConvertToSOModalVisible}
          setVisibility={this.setConvertToSOModalVisibility}
          selectedRows={this.state.selectedRows}
          fetchCustomers={this.props.fetchCustomers}
          customers={this.props.customers}
          selectedCompany={this.props.selectedCompany}
          fetchSalesCustomerDetail={this.props.fetchSalesCustomerDetail}
          salesShippingCustomerDetails={this.props.salesShippingCustomerDetails}
          selectedWarehouse={this.props.selectedWarehouse}
        />
                <EmailContentModal
          visible={this.state.emailContentModalVisibility}
          subject={this.state.emailSubjectTemplate}
          content={this.state.emailContentTemplate}
          onConfirm={this.handleEmailContentConfirm}
          onClose={this.handleEmailContentClose}
          source={'PO'}
        />
      </ContentWrapper>
      //---------------
      // End HTML: Purchase Order List
      //---------------
    );
  }
}

PurchaseOrderList.propTypes = propTypes;
export default PurchaseOrderList;



// WEBPACK FOOTER //
// ./master/jsx/components/GL/GLOrderList.jsx